import * as i0 from '@angular/core';
import { InjectionToken, Directive, Input, Output, ContentChild, ContentChildren, Injectable, Inject, APP_INITIALIZER, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import * as atlas from 'azure-maps-control';
import { AuthenticationType } from 'azure-maps-control';
import * as atlasdrawing from 'azure-maps-drawing-tools';
import * as i1 from '@angular/common/http';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import * as atlas$1 from 'azure-maps-rest';

const AZUREMAPS_CONFIG = new InjectionToken('AZUREMAPS_CONFIG');
/**
 * Configuration of the Azure Maps
 */
class AzureMapsConfiguration {
}

class ControlDirective {
}
ControlDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: ControlDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
ControlDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.0.1", type: ControlDirective, inputs: { position: "position" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: ControlDirective, decorators: [{
            type: Directive
        }], propDecorators: { position: [{
                type: Input
            }] } });

class ZoomControlDirective extends ControlDirective {
    initialize(map) {
        map.controls.add(new atlas.control.ZoomControl({
            zoomDelta: this.zoomDelta,
            style: this.controlStyle
        }), {
            position: this.position
        });
    }
}
ZoomControlDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: ZoomControlDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
ZoomControlDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.0.1", type: ZoomControlDirective, selector: "[map-zoom-control], map-zoom-control", inputs: { zoomDelta: "zoomDelta", controlStyle: "controlStyle" }, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: ZoomControlDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[map-zoom-control], map-zoom-control'
                }]
        }], propDecorators: { zoomDelta: [{
                type: Input
            }], controlStyle: [{
                type: Input
            }] } });

class PitchControlDirective extends ControlDirective {
    initialize(map) {
        map.controls.add(new atlas.control.PitchControl({
            pitchDegreesDelta: this.pitchDegreesDelta,
            style: this.controlStyle
        }), {
            position: this.position
        });
    }
}
PitchControlDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: PitchControlDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
PitchControlDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.0.1", type: PitchControlDirective, selector: "[map-pitch-control], map-pitch-control", inputs: { pitchDegreesDelta: "pitchDegreesDelta", controlStyle: "controlStyle" }, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: PitchControlDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[map-pitch-control], map-pitch-control'
                }]
        }], propDecorators: { pitchDegreesDelta: [{
                type: Input
            }], controlStyle: [{
                type: Input
            }] } });

class CompassControlDirective extends ControlDirective {
    initialize(map) {
        map.controls.add(new atlas.control.CompassControl({
            rotationDegreesDelta: this.rotationDegreesDelta,
            style: this.controlStyle
        }), {
            position: this.position
        });
    }
}
CompassControlDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: CompassControlDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
CompassControlDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.0.1", type: CompassControlDirective, selector: "[map-compass-control], map-compass-control", inputs: { rotationDegreesDelta: "rotationDegreesDelta", controlStyle: "controlStyle" }, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: CompassControlDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[map-compass-control], map-compass-control'
                }]
        }], propDecorators: { rotationDegreesDelta: [{
                type: Input
            }], controlStyle: [{
                type: Input
            }] } });

class StyleControlDirective extends ControlDirective {
    initialize(map) {
        map.controls.add(new atlas.control.StyleControl({
            layout: this.layout,
            mapStyles: this.mapStyles,
            style: this.controlStyle
        }), {
            position: this.position
        });
    }
}
StyleControlDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: StyleControlDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
StyleControlDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.0.1", type: StyleControlDirective, selector: "[map-style-control], map-style-control", inputs: { layout: "layout", mapStyles: "mapStyles", controlStyle: "controlStyle" }, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: StyleControlDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[map-style-control], map-style-control'
                }]
        }], propDecorators: { layout: [{
                type: Input
            }], mapStyles: [{
                type: Input
            }], controlStyle: [{
                type: Input
            }] } });

class HtmlMarkerDirective {
    constructor() {
        this._markerEvents = new Map([
            ['click', e => this.onClick.next(this.toMarkerEvent(e))],
            ['contextmenu', e => this.onContextMenu.next(this.toMarkerEvent(e))],
            ['dblclick', e => this.onDblClick.next(this.toMarkerEvent(e))],
            ['drag', e => this.onDrag.next(this.toMarkerEvent(e))],
            ['dragstart', e => this.onDragStart.next(this.toMarkerEvent(e))],
            ['dragend', e => this.onDragEnd.next(this.toMarkerEvent(e))],
            ['keydown', e => this.onKeyDown.next(this.toMarkerEvent(e))],
            ['keypress', e => this.onKeyPress.next(this.toMarkerEvent(e))],
            ['keyup', e => this.onKeyUp.next(this.toMarkerEvent(e))],
            ['mousedown', e => this.onMouseDown.next(this.toMarkerEvent(e))],
            ['mouseenter', e => this.onMouseEnter.next(this.toMarkerEvent(e))],
            ['mouseleave', e => this.onMouseLeave.next(this.toMarkerEvent(e))],
            ['mousemove', e => this.onMouseMove.next(this.toMarkerEvent(e))],
            ['mouseout', e => this.onMouseOut.next(this.toMarkerEvent(e))],
            ['mouseover', e => this.onMouseOver.next(this.toMarkerEvent(e))],
            ['mouseup', e => this.onMouseUp.next(this.toMarkerEvent(e))]
        ]);
        this.onClick = new Subject();
        this.onContextMenu = new Subject();
        this.onDblClick = new Subject();
        this.onDrag = new Subject();
        this.onDragStart = new Subject();
        this.onDragEnd = new Subject();
        this.onKeyDown = new Subject();
        this.onKeyPress = new Subject();
        this.onKeyUp = new Subject();
        this.onMouseDown = new Subject();
        this.onMouseEnter = new Subject();
        this.onMouseLeave = new Subject();
        this.onMouseMove = new Subject();
        this.onMouseOut = new Subject();
        this.onMouseOver = new Subject();
        this.onMouseUp = new Subject();
    }
    get hasMap() {
        return !!this._map;
    }
    ngOnChanges() {
        if (this._marker) {
            this._marker.setOptions({
                anchor: this.anchor,
                color: this.color,
                draggable: this.draggable,
                htmlContent: this.htmlContent,
                pixelOffset: this.pixelOffset,
                position: this.position,
                secondaryColor: this.secondaryColor,
                text: this.text,
                visible: this.visible
            });
        }
    }
    ngOnDestroy() {
        if (this._map && this._marker) {
            this._map.markers.remove(this._marker);
        }
    }
    addToMap(map) {
        this._map = map;
        this._marker = this.marker ? this.marker : new atlas.HtmlMarker({
            anchor: this.anchor,
            color: this.color,
            draggable: this.draggable,
            htmlContent: this.htmlContent,
            pixelOffset: this.pixelOffset,
            position: this.position,
            secondaryColor: this.secondaryColor,
            text: this.text,
            visible: this.visible
        });
        this._markerEvents.forEach((value, key) => {
            this._map.events.add(key, this._marker, value);
        });
        map.markers.add(this._marker);
    }
    toMarkerEvent(e) {
        return {
            marker: this._marker,
            event: e
        };
    }
}
HtmlMarkerDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: HtmlMarkerDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
HtmlMarkerDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.0.1", type: HtmlMarkerDirective, selector: "[map-html-marker], map-html-marker", inputs: { anchor: "anchor", color: "color", draggable: "draggable", htmlContent: "htmlContent", pixelOffset: "pixelOffset", position: "position", secondaryColor: "secondaryColor", text: "text", visible: "visible", marker: "marker" }, outputs: { onClick: "onClick", onContextMenu: "onContextMenu", onDblClick: "onDblClick", onDrag: "onDrag", onDragStart: "onDragStart", onDragEnd: "onDragEnd", onKeyDown: "onKeyDown", onKeyPress: "onKeyPress", onKeyUp: "onKeyUp", onMouseDown: "onMouseDown", onMouseEnter: "onMouseEnter", onMouseLeave: "onMouseLeave", onMouseMove: "onMouseMove", onMouseOut: "onMouseOut", onMouseOver: "onMouseOver", onMouseUp: "onMouseUp" }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: HtmlMarkerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[map-html-marker], map-html-marker'
                }]
        }], propDecorators: { anchor: [{
                type: Input
            }], color: [{
                type: Input
            }], draggable: [{
                type: Input
            }], htmlContent: [{
                type: Input
            }], pixelOffset: [{
                type: Input
            }], position: [{
                type: Input
            }], secondaryColor: [{
                type: Input
            }], text: [{
                type: Input
            }], visible: [{
                type: Input
            }], marker: [{
                type: Input
            }], onClick: [{
                type: Output
            }], onContextMenu: [{
                type: Output
            }], onDblClick: [{
                type: Output
            }], onDrag: [{
                type: Output
            }], onDragStart: [{
                type: Output
            }], onDragEnd: [{
                type: Output
            }], onKeyDown: [{
                type: Output
            }], onKeyPress: [{
                type: Output
            }], onKeyUp: [{
                type: Output
            }], onMouseDown: [{
                type: Output
            }], onMouseEnter: [{
                type: Output
            }], onMouseLeave: [{
                type: Output
            }], onMouseMove: [{
                type: Output
            }], onMouseOut: [{
                type: Output
            }], onMouseOver: [{
                type: Output
            }], onMouseUp: [{
                type: Output
            }] } });

class DrawingToolbarDirective {
    constructor() {
        this.drawingChanged = new Subject();
        this.drawingChanging = new Subject();
        this.drawingComplete = new Subject();
        this.drawingModeChanged = new Subject();
        this.drawingStarted = new Subject();
    }
    ngOnChanges() {
        if (this._toolbar) {
            this._toolbar.setOptions({
                buttons: this.buttons,
                containerId: this.containerId,
                numColumns: this.numColumns,
                position: this.position,
                style: this.toolbarStyle,
                visible: this.visible
            });
        }
    }
    ngOnDestroy() {
        if (this._map) {
            this._map.events.remove('drawingchanged', this._drawingManager, null);
            this._map.events.remove('drawingchanging', this._drawingManager, null);
            this._map.events.remove('drawingcomplete', this._drawingManager, null);
            this._map.events.remove('drawingmodechanged', this._drawingManager, null);
            this._map.events.remove('drawingstarted', this._drawingManager, null);
            this._map.controls.remove(this._toolbar);
        }
    }
    initialize(map) {
        this._map = map;
        this._toolbar = new atlasdrawing.control.DrawingToolbar({
            buttons: this.buttons,
            containerId: this.containerId,
            numColumns: this.numColumns,
            position: this.position,
            style: this.toolbarStyle,
            visible: this.visible
        });
        this._drawingManager = new atlasdrawing.drawing.DrawingManager(map, {
            dragHandleStyle: this.dragHandleStyle,
            freehandInterval: this.freehandInterval,
            interactionType: this.interactionType,
            mode: this.mode,
            secondaryDragHandleStyle: this.secondaryDragHandleStyle,
            shapeDraggingEnabled: this.shapeDraggingEnabled,
            toolbar: this._toolbar
        });
        this._map.events.add('drawingchanged', this._drawingManager, e => {
            this.drawingChanged.next(e);
        });
        this._map.events.add('drawingchanging', this._drawingManager, e => {
            this.drawingChanging.next(e);
        });
        this._map.events.add('drawingcomplete', this._drawingManager, e => {
            this.drawingComplete.next(e);
        });
        this._map.events.add('drawingmodechanged', this._drawingManager, e => {
            this.drawingModeChanged.next(e);
        });
        this._map.events.add('drawingstarted', this._drawingManager, e => {
            this.drawingStarted.next(e);
        });
    }
    getDatasource() {
        return this._drawingManager.getSource();
    }
    getPreviewSource() {
        return this._drawingManager.drawingHelper.previewSource;
    }
}
DrawingToolbarDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: DrawingToolbarDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
DrawingToolbarDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.0.1", type: DrawingToolbarDirective, selector: "[map-drawing-toolbar], map-drawing-toolbar", inputs: { dragHandleStyle: "dragHandleStyle", freehandInterval: "freehandInterval", interactionType: "interactionType", mode: "mode", secondaryDragHandleStyle: "secondaryDragHandleStyle", shapeDraggingEnabled: "shapeDraggingEnabled", buttons: "buttons", containerId: "containerId", numColumns: "numColumns", position: "position", toolbarStyle: "toolbarStyle", visible: "visible" }, outputs: { drawingChanged: "drawingChanged", drawingChanging: "drawingChanging", drawingComplete: "drawingComplete", drawingModeChanged: "drawingModeChanged", drawingStarted: "drawingStarted" }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: DrawingToolbarDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[map-drawing-toolbar], map-drawing-toolbar'
                }]
        }], propDecorators: { dragHandleStyle: [{
                type: Input
            }], freehandInterval: [{
                type: Input
            }], interactionType: [{
                type: Input
            }], mode: [{
                type: Input
            }], secondaryDragHandleStyle: [{
                type: Input
            }], shapeDraggingEnabled: [{
                type: Input
            }], buttons: [{
                type: Input
            }], containerId: [{
                type: Input
            }], numColumns: [{
                type: Input
            }], position: [{
                type: Input
            }], toolbarStyle: [{
                type: Input
            }], visible: [{
                type: Input
            }], drawingChanged: [{
                type: Output
            }], drawingChanging: [{
                type: Output
            }], drawingComplete: [{
                type: Output
            }], drawingModeChanged: [{
                type: Output
            }], drawingStarted: [{
                type: Output
            }] } });

class LayerDirective {
    constructor() {
        this._layerEvents = new Map([
            ['click', e => this.onClick.next(this.toLayerEvent(this.layer, e))],
            ['contextmenu', e => this.onContextMenu.next(this.toLayerEvent(this.layer, e))],
            ['dblclick', e => this.onDblClick.next(this.toLayerEvent(this.layer, e))],
            ['layeradded', e => this.onAdded.next(this.toLayerEvent(this.layer, e))],
            ['layerremoved', e => this.onRemoved.next(this.toLayerEvent(this.layer, e))],
            ['mousedown', e => this.onMouseDown.next(this.toLayerEvent(this.layer, e))],
            ['mouseenter', e => this.onMouseEnter.next(this.toLayerEvent(this.layer, e))],
            ['mouseleave', e => this.onMouseLeave.next(this.toLayerEvent(this.layer, e))],
            ['mousemove', e => this.onMouseMove.next(this.toLayerEvent(this.layer, e))],
            ['mouseout', e => this.onMouseOut.next(this.toLayerEvent(this.layer, e))],
            ['mouseover', e => this.onMouseOver.next(this.toLayerEvent(this.layer, e))],
            ['mouseup', e => this.onMouseUp.next(this.toLayerEvent(this.layer, e))],
            ['touchcancel', e => this.onTouchCancel.next(this.toLayerEvent(this.layer, e))],
            ['touchend', e => this.onTouchEnd.next(this.toLayerEvent(this.layer, e))],
            ['touchmove', e => this.onTouchMove.next(this.toLayerEvent(this.layer, e))],
            ['touchstart', e => this.onTouchStart.next(this.toLayerEvent(this.layer, e))],
            ['wheel', e => this.onWheel.next(this.toLayerEvent(this.layer, e))],
        ]);
        this.onAdded = new Subject();
        this.onClick = new Subject();
        this.onContextMenu = new Subject();
        this.onDblClick = new Subject();
        this.onMouseDown = new Subject();
        this.onMouseEnter = new Subject();
        this.onMouseLeave = new Subject();
        this.onMouseMove = new Subject();
        this.onMouseOut = new Subject();
        this.onMouseOver = new Subject();
        this.onMouseUp = new Subject();
        this.onRemoved = new Subject();
        this.onTouchCancel = new Subject();
        this.onTouchEnd = new Subject();
        this.onTouchMove = new Subject();
        this.onTouchStart = new Subject();
        this.onWheel = new Subject();
    }
    get hasLayer() {
        return !!this.layer;
    }
    ngOnDestroy() {
        this.layer.getMap().layers.remove(this.layer);
    }
    initializeEvents(map) {
        this._layerEvents.forEach((value, key) => {
            map.events.add(key, this.layer, value);
        });
    }
    toLayerEvent(layer, e) {
        return {
            layer,
            event: e
        };
    }
}
LayerDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: LayerDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
LayerDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.0.1", type: LayerDirective, inputs: { id: "id", before: "before" }, outputs: { onAdded: "onAdded", onClick: "onClick", onContextMenu: "onContextMenu", onDblClick: "onDblClick", onMouseDown: "onMouseDown", onMouseEnter: "onMouseEnter", onMouseLeave: "onMouseLeave", onMouseMove: "onMouseMove", onMouseOut: "onMouseOut", onMouseOver: "onMouseOver", onMouseUp: "onMouseUp", onRemoved: "onRemoved", onTouchCancel: "onTouchCancel", onTouchEnd: "onTouchEnd", onTouchMove: "onTouchMove", onTouchStart: "onTouchStart", onWheel: "onWheel" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: LayerDirective, decorators: [{
            type: Directive
        }], propDecorators: { id: [{
                type: Input
            }], before: [{
                type: Input
            }], onAdded: [{
                type: Output
            }], onClick: [{
                type: Output
            }], onContextMenu: [{
                type: Output
            }], onDblClick: [{
                type: Output
            }], onMouseDown: [{
                type: Output
            }], onMouseEnter: [{
                type: Output
            }], onMouseLeave: [{
                type: Output
            }], onMouseMove: [{
                type: Output
            }], onMouseOut: [{
                type: Output
            }], onMouseOver: [{
                type: Output
            }], onMouseUp: [{
                type: Output
            }], onRemoved: [{
                type: Output
            }], onTouchCancel: [{
                type: Output
            }], onTouchEnd: [{
                type: Output
            }], onTouchMove: [{
                type: Output
            }], onTouchStart: [{
                type: Output
            }], onWheel: [{
                type: Output
            }] } });

class SourceLayerDirective extends LayerDirective {
    initialize(map, dataSource) {
        this.layer = this.buildLayer(dataSource);
        this.initializeEvents(map);
        map.layers.add(this.layer, this.before);
    }
    ;
    clear(map) {
        map.layers.remove(this.layer);
        this.layer = null;
    }
}
SourceLayerDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: SourceLayerDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
SourceLayerDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.0.1", type: SourceLayerDirective, inputs: { dataSourceId: "dataSourceId", sourceLayer: "sourceLayer" }, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: SourceLayerDirective, decorators: [{
            type: Directive
        }], propDecorators: { dataSourceId: [{
                type: Input
            }], sourceLayer: [{
                type: Input
            }] } });

class SymbolLayerDirective extends SourceLayerDirective {
    ngOnChanges() {
        if (this.layer) {
            this.layer.setOptions({
                filter: this.filter,
                iconOptions: this.iconOptions,
                lineSpacing: this.lineSpacing,
                maxZoom: this.maxZoom,
                minZoom: this.minZoom,
                source: this.dataSourceId,
                sourceLayer: this.sourceLayer,
                placement: this.placement,
                textOptions: this.textOptions,
                visible: this.visible
            });
        }
    }
    buildLayer(dataSource) {
        return new atlas.layer.SymbolLayer(dataSource, this.id, {
            filter: this.filter,
            iconOptions: this.iconOptions,
            lineSpacing: this.lineSpacing,
            maxZoom: this.maxZoom,
            minZoom: this.minZoom,
            source: this.dataSourceId,
            sourceLayer: this.sourceLayer,
            placement: this.placement,
            textOptions: this.textOptions,
            visible: this.visible
        });
    }
}
SymbolLayerDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: SymbolLayerDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
SymbolLayerDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.0.1", type: SymbolLayerDirective, selector: "[map-symbol-layer], map-symbol-layer", inputs: { filter: "filter", iconOptions: "iconOptions", lineSpacing: "lineSpacing", maxZoom: "maxZoom", minZoom: "minZoom", placement: "placement", textOptions: "textOptions", visible: "visible" }, usesInheritance: true, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: SymbolLayerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[map-symbol-layer], map-symbol-layer'
                }]
        }], propDecorators: { filter: [{
                type: Input
            }], iconOptions: [{
                type: Input
            }], lineSpacing: [{
                type: Input
            }], maxZoom: [{
                type: Input
            }], minZoom: [{
                type: Input
            }], placement: [{
                type: Input
            }], textOptions: [{
                type: Input
            }], visible: [{
                type: Input
            }] } });

class BubbleLayerDirective extends SourceLayerDirective {
    ngOnChanges() {
        if (this.layer) {
            this.layer.setOptions({
                blur: this.blur,
                color: this.color,
                filter: this.filter,
                maxZoom: this.maxZoom,
                minZoom: this.minZoom,
                opacity: this.opacity,
                pitchAlignment: this.pitchAlignment,
                radius: this.radius,
                source: this.dataSourceId,
                sourceLayer: this.sourceLayer,
                strokeColor: this.strokeColor,
                strokeOpacity: this.strokeOpacity,
                strokeWidth: this.strokeWidth,
                visible: this.visible
            });
        }
    }
    buildLayer(dataSource) {
        return new atlas.layer.BubbleLayer(dataSource, this.id, {
            blur: this.blur,
            color: this.color,
            filter: this.filter,
            maxZoom: this.maxZoom,
            minZoom: this.minZoom,
            opacity: this.opacity,
            pitchAlignment: this.pitchAlignment,
            radius: this.radius,
            source: this.dataSourceId,
            sourceLayer: this.sourceLayer,
            strokeColor: this.strokeColor,
            strokeOpacity: this.strokeOpacity,
            strokeWidth: this.strokeWidth,
            visible: this.visible
        });
    }
}
BubbleLayerDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: BubbleLayerDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
BubbleLayerDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.0.1", type: BubbleLayerDirective, selector: "[map-bubble-layer], map-bubble-layer", inputs: { blur: "blur", color: "color", filter: "filter", maxZoom: "maxZoom", minZoom: "minZoom", opacity: "opacity", pitchAlignment: "pitchAlignment", radius: "radius", strokeColor: "strokeColor", strokeOpacity: "strokeOpacity", strokeWidth: "strokeWidth", visible: "visible" }, usesInheritance: true, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: BubbleLayerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[map-bubble-layer], map-bubble-layer'
                }]
        }], propDecorators: { blur: [{
                type: Input
            }], color: [{
                type: Input
            }], filter: [{
                type: Input
            }], maxZoom: [{
                type: Input
            }], minZoom: [{
                type: Input
            }], opacity: [{
                type: Input
            }], pitchAlignment: [{
                type: Input
            }], radius: [{
                type: Input
            }], strokeColor: [{
                type: Input
            }], strokeOpacity: [{
                type: Input
            }], strokeWidth: [{
                type: Input
            }], visible: [{
                type: Input
            }] } });

class LineLayerDirective extends SourceLayerDirective {
    ngOnChanges() {
        if (this.layer) {
            this.layer.setOptions({
                blur: this.blur,
                filter: this.filter,
                lineCap: this.lineCap,
                lineJoin: this.lineJoin,
                maxZoom: this.maxZoom,
                minZoom: this.minZoom,
                offset: this.offset,
                source: this.dataSourceId,
                sourceLayer: this.sourceLayer,
                strokeColor: this.strokeColor,
                strokeDashArray: this.strokeDashArray,
                strokeGradient: this.strokeGradient,
                strokeOpacity: this.strokeOpacity,
                strokeWidth: this.strokeWidth,
                translate: this.translate,
                translateAnchor: this.translateAnchor,
                visible: this.visible
            });
        }
    }
    buildLayer(dataSource) {
        if (this.strokeGradient && dataSource.setOptions) {
            dataSource.setOptions({
                lineMetrics: true
            });
        }
        return new atlas.layer.LineLayer(dataSource, this.id, {
            blur: this.blur,
            filter: this.filter,
            lineCap: this.lineCap,
            lineJoin: this.lineJoin,
            maxZoom: this.maxZoom,
            minZoom: this.minZoom,
            offset: this.offset,
            source: this.dataSourceId,
            sourceLayer: this.sourceLayer,
            strokeColor: this.strokeColor,
            strokeDashArray: this.strokeDashArray,
            strokeGradient: this.strokeGradient,
            strokeOpacity: this.strokeOpacity,
            strokeWidth: this.strokeWidth,
            translate: this.translate,
            translateAnchor: this.translateAnchor,
            visible: this.visible
        });
    }
}
LineLayerDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: LineLayerDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
LineLayerDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.0.1", type: LineLayerDirective, selector: "[map-line-layer], map-line-layer", inputs: { blur: "blur", filter: "filter", lineCap: "lineCap", lineJoin: "lineJoin", maxZoom: "maxZoom", minZoom: "minZoom", offset: "offset", strokeColor: "strokeColor", strokeDashArray: "strokeDashArray", strokeGradient: "strokeGradient", strokeOpacity: "strokeOpacity", strokeWidth: "strokeWidth", translate: "translate", translateAnchor: "translateAnchor", visible: "visible" }, usesInheritance: true, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: LineLayerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[map-line-layer], map-line-layer'
                }]
        }], propDecorators: { blur: [{
                type: Input
            }], filter: [{
                type: Input
            }], lineCap: [{
                type: Input
            }], lineJoin: [{
                type: Input
            }], maxZoom: [{
                type: Input
            }], minZoom: [{
                type: Input
            }], offset: [{
                type: Input
            }], strokeColor: [{
                type: Input
            }], strokeDashArray: [{
                type: Input
            }], strokeGradient: [{
                type: Input
            }], strokeOpacity: [{
                type: Input
            }], strokeWidth: [{
                type: Input
            }], translate: [{
                type: Input
            }], translateAnchor: [{
                type: Input
            }], visible: [{
                type: Input
            }] } });

class PolygonLayerDirective extends SourceLayerDirective {
    ngOnChanges() {
        if (this.layer) {
            this.layer.setOptions({
                fillColor: this.fillColor,
                fillOpacity: this.fillOpacity,
                fillPattern: this.fillPattern,
                filter: this.filter,
                maxZoom: this.maxZoom,
                minZoom: this.minZoom,
                source: this.dataSourceId,
                sourceLayer: this.sourceLayer,
                visible: this.visible
            });
        }
    }
    buildLayer(dataSource) {
        return new atlas.layer.PolygonLayer(dataSource, this.id, {
            fillColor: this.fillColor,
            fillOpacity: this.fillOpacity,
            fillPattern: this.fillPattern,
            filter: this.filter,
            maxZoom: this.maxZoom,
            minZoom: this.minZoom,
            source: this.dataSourceId,
            sourceLayer: this.sourceLayer,
            visible: this.visible
        });
    }
}
PolygonLayerDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: PolygonLayerDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
PolygonLayerDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.0.1", type: PolygonLayerDirective, selector: "[map-polygon-layer], map-polygon-layer", inputs: { fillColor: "fillColor", fillOpacity: "fillOpacity", fillPattern: "fillPattern", filter: "filter", maxZoom: "maxZoom", minZoom: "minZoom", visible: "visible" }, usesInheritance: true, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: PolygonLayerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[map-polygon-layer], map-polygon-layer'
                }]
        }], propDecorators: { fillColor: [{
                type: Input
            }], fillOpacity: [{
                type: Input
            }], fillPattern: [{
                type: Input
            }], filter: [{
                type: Input
            }], maxZoom: [{
                type: Input
            }], minZoom: [{
                type: Input
            }], visible: [{
                type: Input
            }] } });

class PolygonExtrusionLayerDirective extends SourceLayerDirective {
    ngOnChanges() {
        if (this.layer) {
            this.layer.setOptions({
                base: this.base,
                fillColor: this.fillColor,
                fillOpacity: this.fillOpacity,
                fillPattern: this.fillPattern,
                filter: this.filter,
                height: this.height,
                maxZoom: this.maxZoom,
                minZoom: this.minZoom,
                source: this.dataSourceId,
                sourceLayer: this.sourceLayer,
                translate: this.translate,
                translateAnchor: this.translateAnchor,
                verticalGradient: this.verticalGradient,
                visible: this.visible
            });
        }
    }
    buildLayer(dataSource) {
        return new atlas.layer.PolygonExtrusionLayer(dataSource, this.id, {
            base: this.base,
            fillColor: this.fillColor,
            fillOpacity: this.fillOpacity,
            fillPattern: this.fillPattern,
            filter: this.filter,
            height: this.height,
            maxZoom: this.maxZoom,
            minZoom: this.minZoom,
            source: this.dataSourceId,
            sourceLayer: this.sourceLayer,
            translate: this.translate,
            translateAnchor: this.translateAnchor,
            verticalGradient: this.verticalGradient,
            visible: this.visible
        });
    }
}
PolygonExtrusionLayerDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: PolygonExtrusionLayerDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
PolygonExtrusionLayerDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.0.1", type: PolygonExtrusionLayerDirective, selector: "[map-polygon-extrusion-layer], map-polygon-extrusion-layer", inputs: { base: "base", fillColor: "fillColor", fillOpacity: "fillOpacity", fillPattern: "fillPattern", filter: "filter", height: "height", maxZoom: "maxZoom", minZoom: "minZoom", translate: "translate", translateAnchor: "translateAnchor", verticalGradient: "verticalGradient", visible: "visible" }, usesInheritance: true, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: PolygonExtrusionLayerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[map-polygon-extrusion-layer], map-polygon-extrusion-layer'
                }]
        }], propDecorators: { base: [{
                type: Input
            }], fillColor: [{
                type: Input
            }], fillOpacity: [{
                type: Input
            }], fillPattern: [{
                type: Input
            }], filter: [{
                type: Input
            }], height: [{
                type: Input
            }], maxZoom: [{
                type: Input
            }], minZoom: [{
                type: Input
            }], translate: [{
                type: Input
            }], translateAnchor: [{
                type: Input
            }], verticalGradient: [{
                type: Input
            }], visible: [{
                type: Input
            }] } });

class HeatmapLayerDirective extends SourceLayerDirective {
    ngOnChanges() {
        if (this.layer) {
            this.layer.setOptions({
                color: this.color,
                filter: this.filter,
                intensity: this.intensity,
                maxZoom: this.maxZoom,
                minZoom: this.minZoom,
                opacity: this.opacity,
                radius: this.radius,
                source: this.dataSourceId,
                sourceLayer: this.sourceLayer,
                visible: this.visible,
                weight: this.weight
            });
        }
    }
    buildLayer(dataSource) {
        return new atlas.layer.HeatMapLayer(dataSource, this.id, {
            color: this.color,
            filter: this.filter,
            intensity: this.intensity,
            maxZoom: this.maxZoom,
            minZoom: this.minZoom,
            opacity: this.opacity,
            radius: this.radius,
            source: this.dataSourceId,
            sourceLayer: this.sourceLayer,
            visible: this.visible,
            weight: this.weight
        });
    }
}
HeatmapLayerDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: HeatmapLayerDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
HeatmapLayerDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.0.1", type: HeatmapLayerDirective, selector: "[map-heatmap-layer], map-heatmap-layer", inputs: { color: "color", filter: "filter", intensity: "intensity", maxZoom: "maxZoom", minZoom: "minZoom", opacity: "opacity", radius: "radius", visible: "visible", weight: "weight" }, usesInheritance: true, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: HeatmapLayerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[map-heatmap-layer], map-heatmap-layer'
                }]
        }], propDecorators: { color: [{
                type: Input
            }], filter: [{
                type: Input
            }], intensity: [{
                type: Input
            }], maxZoom: [{
                type: Input
            }], minZoom: [{
                type: Input
            }], opacity: [{
                type: Input
            }], radius: [{
                type: Input
            }], visible: [{
                type: Input
            }], weight: [{
                type: Input
            }] } });

class ImageLayerDirective extends LayerDirective {
    ngOnChanges() {
        if (this.layer) {
            this.layer.setOptions({
                contrast: this.contrast,
                coordinates: this.coordinates,
                fadeDuration: this.fadeDuration,
                filter: this.filter,
                hueRotation: this.hueRotation,
                maxBrightness: this.maxBrightness,
                maxZoom: this.maxZoom,
                minBrightness: this.minBrightness,
                minZoom: this.minZoom,
                opacity: this.opacity,
                saturation: this.saturation,
                url: this.url,
                visible: this.visible
            });
        }
    }
    initialize(map) {
        this.layer = new atlas.layer.ImageLayer({
            contrast: this.contrast,
            coordinates: this.coordinates,
            fadeDuration: this.fadeDuration,
            filter: this.filter,
            hueRotation: this.hueRotation,
            maxBrightness: this.maxBrightness,
            maxZoom: this.maxZoom,
            minBrightness: this.minBrightness,
            minZoom: this.minZoom,
            opacity: this.opacity,
            saturation: this.saturation,
            url: this.url,
            visible: this.visible
        });
        this.initializeEvents(map);
        map.layers.add(this.layer, this.before);
    }
}
ImageLayerDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: ImageLayerDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
ImageLayerDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.0.1", type: ImageLayerDirective, selector: "[map-image-layer], map-image-layer", inputs: { contrast: "contrast", coordinates: "coordinates", fadeDuration: "fadeDuration", filter: "filter", hueRotation: "hueRotation", maxBrightness: "maxBrightness", maxZoom: "maxZoom", minBrightness: "minBrightness", minZoom: "minZoom", opacity: "opacity", saturation: "saturation", url: "url", visible: "visible" }, usesInheritance: true, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: ImageLayerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[map-image-layer], map-image-layer'
                }]
        }], propDecorators: { contrast: [{
                type: Input
            }], coordinates: [{
                type: Input
            }], fadeDuration: [{
                type: Input
            }], filter: [{
                type: Input
            }], hueRotation: [{
                type: Input
            }], maxBrightness: [{
                type: Input
            }], maxZoom: [{
                type: Input
            }], minBrightness: [{
                type: Input
            }], minZoom: [{
                type: Input
            }], opacity: [{
                type: Input
            }], saturation: [{
                type: Input
            }], url: [{
                type: Input
            }], visible: [{
                type: Input
            }] } });

class TileLayerDirective extends LayerDirective {
    ngOnChanges() {
        if (this.layer) {
            this.layer.setOptions({
                bounds: this.bounds,
                contrast: this.contrast,
                fadeDuration: this.fadeDuration,
                filter: this.filter,
                hueRotation: this.hueRotation,
                isTMS: this.isTMS,
                maxBrightness: this.maxBrightness,
                maxSourceZoom: this.maxSourceZoom,
                maxZoom: this.maxZoom,
                minBrightness: this.minBrightness,
                minSourceZoom: this.minSourceZoom,
                minZoom: this.minZoom,
                opacity: this.opacity,
                saturation: this.saturation,
                subdomains: this.subdomains,
                tileSize: this.tileSize,
                tileUrl: this.tileUrl,
                visible: this.visible
            });
        }
    }
    initialize(map) {
        this.layer = new atlas.layer.TileLayer({
            bounds: this.bounds,
            contrast: this.contrast,
            fadeDuration: this.fadeDuration,
            filter: this.filter,
            hueRotation: this.hueRotation,
            isTMS: this.isTMS,
            maxBrightness: this.maxBrightness,
            maxSourceZoom: this.maxSourceZoom,
            maxZoom: this.maxZoom,
            minBrightness: this.minBrightness,
            minSourceZoom: this.minSourceZoom,
            minZoom: this.minZoom,
            opacity: this.opacity,
            saturation: this.saturation,
            subdomains: this.subdomains,
            tileSize: this.tileSize,
            tileUrl: this.tileUrl,
            visible: this.visible
        }, this.id);
        this.initializeEvents(map);
        map.layers.add(this.layer, this.before);
    }
}
TileLayerDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: TileLayerDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
TileLayerDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.0.1", type: TileLayerDirective, selector: "[map-tile-layer], map-tile-layer", inputs: { bounds: "bounds", contrast: "contrast", fadeDuration: "fadeDuration", filter: "filter", hueRotation: "hueRotation", isTMS: "isTMS", maxBrightness: "maxBrightness", maxSourceZoom: "maxSourceZoom", maxZoom: "maxZoom", minBrightness: "minBrightness", minSourceZoom: "minSourceZoom", minZoom: "minZoom", opacity: "opacity", saturation: "saturation", subdomains: "subdomains", tileSize: "tileSize", tileUrl: "tileUrl", visible: "visible" }, usesInheritance: true, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: TileLayerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[map-tile-layer], map-tile-layer'
                }]
        }], propDecorators: { bounds: [{
                type: Input
            }], contrast: [{
                type: Input
            }], fadeDuration: [{
                type: Input
            }], filter: [{
                type: Input
            }], hueRotation: [{
                type: Input
            }], isTMS: [{
                type: Input
            }], maxBrightness: [{
                type: Input
            }], maxSourceZoom: [{
                type: Input
            }], maxZoom: [{
                type: Input
            }], minBrightness: [{
                type: Input
            }], minSourceZoom: [{
                type: Input
            }], minZoom: [{
                type: Input
            }], opacity: [{
                type: Input
            }], saturation: [{
                type: Input
            }], subdomains: [{
                type: Input
            }], tileSize: [{
                type: Input
            }], tileUrl: [{
                type: Input
            }], visible: [{
                type: Input
            }] } });

class PopupDirective {
    constructor() {
        this._popupEvents = new Map([
            ['close', e => this.onClose.next(this.toPopupEvent(e))],
            ['drag', e => this.onDrag.next(this.toPopupEvent(e))],
            ['dragend', e => this.onDragEnd.next(this.toPopupEvent(e))],
            ['dragstart', e => this.onDragStart.next(this.toPopupEvent(e))],
            ['open', e => this.onOpen.next(this.toPopupEvent(e))],
        ]);
        this.onClose = new Subject();
        this.onDrag = new Subject();
        this.onDragEnd = new Subject();
        this.onDragStart = new Subject();
        this.onOpen = new Subject();
    }
    get hasMap() {
        return !!this._map;
    }
    ngOnChanges(changes) {
        if (this._popup) {
            this._popup.setOptions({
                closeButton: this.closeButton,
                content: this.content,
                draggable: this.draggable,
                fillColor: this.fillColor,
                pixelOffset: this.pixelOffset,
                position: this.position,
                showPointer: this.showPointer
            });
            if (changes.opened) {
                if (changes.opened.currentValue && !this._popup.isOpen()) {
                    this._popup.open(this._map);
                }
                if (!changes.opened.currentValue && this._popup.isOpen()) {
                    this._popup.close();
                }
            }
        }
    }
    ngOnDestroy() {
        if (this._map) {
            this._map.popups.remove(this._popup);
        }
    }
    addToMap(map) {
        this._map = map;
        this._popup = new atlas.Popup({
            closeButton: this.closeButton,
            content: this.content,
            draggable: this.draggable,
            fillColor: this.fillColor,
            pixelOffset: this.pixelOffset,
            position: this.position,
            showPointer: this.showPointer
        });
        this._popupEvents.forEach((value, key) => {
            this._map.events.add(key, this._popup, value);
        });
        map.popups.add(this._popup);
    }
    toPopupEvent(e) {
        return {
            popup: this._popup,
            event: e
        };
    }
}
PopupDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: PopupDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
PopupDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.0.1", type: PopupDirective, selector: "[map-popup], map-popup", inputs: { opened: "opened", closeButton: "closeButton", content: "content", draggable: "draggable", fillColor: "fillColor", pixelOffset: "pixelOffset", position: "position", showPointer: "showPointer" }, outputs: { onClose: "onClose", onDrag: "onDrag", onDragEnd: "onDragEnd", onDragStart: "onDragStart", onOpen: "onOpen" }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: PopupDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[map-popup], map-popup'
                }]
        }], propDecorators: { opened: [{
                type: Input
            }], closeButton: [{
                type: Input
            }], content: [{
                type: Input
            }], draggable: [{
                type: Input
            }], fillColor: [{
                type: Input
            }], pixelOffset: [{
                type: Input
            }], position: [{
                type: Input
            }], showPointer: [{
                type: Input
            }], onClose: [{
                type: Output
            }], onDrag: [{
                type: Output
            }], onDragEnd: [{
                type: Output
            }], onDragStart: [{
                type: Output
            }], onOpen: [{
                type: Output
            }] } });

class AzureMapDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this._mapEvents = new Map([
            ['boxzoomend', e => this.onBoxZoomEnd.next(this.toMapEvent(e))],
            ['boxzoomstart', e => this.onBoxZoomStart.next(this.toMapEvent(e))],
            ['click', e => this.onClick.next(this.toMapEvent(e))],
            ['contextmenu', e => this.onContextMenu.next(this.toMapEvent(e))],
            ['data', e => this.onData.next(this.toMapEvent(e))],
            ['dblclick', e => this.onDblClick.next(this.toMapEvent(e))],
            ['drag', e => this.onDrag.next(this.toMapEvent(e))],
            ['dragend', e => this.onDragEnd.next(this.toMapEvent(e))],
            ['dragstart', e => this.onDragStart.next(this.toMapEvent(e))],
            ['idle', e => this.onIdle.next(this.toMapEvent(e))],
            ['layeradded', e => this.onLayerAdded.next(this.toMapEvent(e))],
            ['layerremoved', e => this.onLayerRemoved.next(this.toMapEvent(e))],
            ['mousedown', e => this.onMouseDown.next(this.toMapEvent(e))],
            ['mouseleave', e => this.onMouseLeave.next(this.toMapEvent(e))],
            ['mousemove', e => this.onMouseMove.next(this.toMapEvent(e))],
            ['mouseout', e => this.onMouseOut.next(this.toMapEvent(e))],
            ['mouseover', e => this.onMouseOver.next(this.toMapEvent(e))],
            ['mouseup', e => this.onMouseUp.next(this.toMapEvent(e))],
            ['move', e => this.onMove.next(this.toMapEvent(e))],
            ['moveend', e => this.onMoveEnd.next(this.toMapEvent(e))],
            ['movestart', e => this.onMoveStart.next(this.toMapEvent(e))],
            ['pitch', e => this.onPitch.next(this.toMapEvent(e))],
            ['pitchend', e => this.onPitchEnd.next(this.toMapEvent(e))],
            ['pitchstart', e => this.onPitchStart.next(this.toMapEvent(e))],
            ['render', e => this.onRender.next(this.toMapEvent(e))],
            ['resize', e => this.onResize.next(this.toMapEvent(e))],
            ['rotate', e => this.onRotate.next(this.toMapEvent(e))],
            ['rotateend', e => this.onRotateEnd.next(this.toMapEvent(e))],
            ['rotatestart', e => this.onRotateStart.next(this.toMapEvent(e))],
            ['sourceadded', e => this.onSourceAdded.next(this.toMapEvent(e))],
            ['sourcedata', e => this.onSourceData.next(this.toMapEvent(e))],
            ['sourceremoved', e => this.onSourceRemoved.next(this.toMapEvent(e))],
            ['styledata', e => this.onStyleData.next(this.toMapEvent(e))],
            ['styleimagemissing', e => this.onStyleImageMissing.next(this.toMapEvent(e))],
            ['tokenacquired', e => this.onTokenAcquired.next(this.toMapEvent(e))],
            ['touchcancel', e => this.onTouchCancel.next(this.toMapEvent(e))],
            ['touchend', e => this.onTouchEnd.next(this.toMapEvent(e))],
            ['touchmove', e => this.onTouchMove.next(this.toMapEvent(e))],
            ['touchstart', e => this.onTouchStart.next(this.toMapEvent(e))],
            ['wheel', e => this.onWheel.next(this.toMapEvent(e))],
            ['zoom', e => this.onZoom.next(this.toMapEvent(e))],
            ['zoomend', e => this.onZoomEnd.next(this.toMapEvent(e))],
            ['zoomstart', e => this.onZoomStart.next(this.toMapEvent(e))]
        ]);
        this.onBoxZoomEnd = new Subject();
        this.onBoxZoomStart = new Subject();
        this.onClick = new Subject();
        this.onContextMenu = new Subject();
        this.onData = new Subject();
        this.onDblClick = new Subject();
        this.onDrag = new Subject();
        this.onDragEnd = new Subject();
        this.onDragStart = new Subject();
        this.onError = new Subject();
        this.onIdle = new Subject();
        this.onLayerAdded = new Subject();
        this.onLayerRemoved = new Subject();
        this.onLoad = new Subject();
        this.onMouseDown = new Subject();
        this.onMouseLeave = new Subject();
        this.onMouseMove = new Subject();
        this.onMouseOut = new Subject();
        this.onMouseOver = new Subject();
        this.onMouseUp = new Subject();
        this.onMove = new Subject();
        this.onMoveEnd = new Subject();
        this.onMoveStart = new Subject();
        this.onPitch = new Subject();
        this.onPitchEnd = new Subject();
        this.onPitchStart = new Subject();
        this.onReady = new Subject();
        this.onRender = new Subject();
        this.onResize = new Subject();
        this.onRotate = new Subject();
        this.onRotateEnd = new Subject();
        this.onRotateStart = new Subject();
        this.onSourceAdded = new Subject();
        this.onSourceData = new Subject();
        this.onSourceRemoved = new Subject();
        this.onStyleData = new Subject();
        this.onStyleImageMissing = new Subject();
        this.onTokenAcquired = new Subject();
        this.onTouchCancel = new Subject();
        this.onTouchEnd = new Subject();
        this.onTouchMove = new Subject();
        this.onTouchStart = new Subject();
        this.onWheel = new Subject();
        this.onZoom = new Subject();
        this.onZoomEnd = new Subject();
        this.onZoomStart = new Subject();
    }
    get sourceLayers() {
        const result = [];
        if (this.symbolLayers.length > 0) {
            result.push(...this.symbolLayers.toArray());
        }
        if (this.bubbleLayers.length > 0) {
            result.push(...this.bubbleLayers.toArray());
        }
        if (this.lineLayers.length > 0) {
            result.push(...this.lineLayers.toArray());
        }
        if (this.polygonLayers.length > 0) {
            result.push(...this.polygonLayers.toArray());
        }
        if (this.polygonExtrusionLayers.length > 0) {
            result.push(...this.polygonExtrusionLayers.toArray());
        }
        if (this.heatmapLayers.length > 0) {
            result.push(...this.heatmapLayers.toArray());
        }
        return result;
    }
    ngAfterViewInit() {
        const map = new atlas.Map(this.elementRef.nativeElement, {
            disableTelemetry: this.disableTelemetry,
            enableAccessibility: this.enableAccessibility,
            refreshExpiredTiles: this.refreshExpiredTiles
        });
        map.events.add('error', e => {
            this.onError.next({
                event: e,
                map
            });
        });
        map.events.addOnce('ready', e => {
            this._map = map;
            this.setOptions();
            this.onReady.next(this.toMapEvent(e));
            this._mapEvents.forEach((value, key) => {
                this._map.events.add(key, value);
            });
            if (this.zoomControl) {
                this.zoomControl.initialize(this._map);
            }
            if (this.pitchControl) {
                this.pitchControl.initialize(this._map);
            }
            if (this.compassControl) {
                this.compassControl.initialize(this._map);
            }
            if (this.styleControl) {
                this.styleControl.initialize(this._map);
            }
            if (this.drawingToolbar) {
                this.drawingToolbar.initialize(this._map);
            }
            this.updateDataSources();
        });
        map.events.addOnce('load', e => {
            if (this.cursor) {
                this._map.getCanvasContainer().style.cursor = this.cursor;
            }
            this.onLoad.next(this.toMapEvent(e));
        });
    }
    ngAfterContentChecked() {
        if (this._map) {
            if (this.htmlMarkers) {
                for (const marker of this.htmlMarkers.filter(m => !m.hasMap)) {
                    marker.addToMap(this._map);
                }
            }
            if (this.sourceLayers.length > 0 && this.dataSources) {
                for (const layer of this.sourceLayers.filter(l => !l.hasLayer)) {
                    const dataSource = this.dataSources.find(d => d && d.getId() === layer.dataSourceId);
                    if (dataSource) {
                        layer.initialize(this._map, dataSource);
                    }
                }
            }
            if (this.imageLayers.length > 0) {
                for (const layer of this.imageLayers.filter(l => !l.hasLayer)) {
                    layer.initialize(this._map);
                }
            }
            if (this.tileLayers.length > 0) {
                for (const layer of this.tileLayers.filter(l => !l.hasLayer)) {
                    layer.initialize(this._map);
                }
            }
            if (this.popups) {
                for (const popup of this.popups.filter(m => !m.hasMap)) {
                    popup.addToMap(this._map);
                }
            }
        }
    }
    ngOnChanges(changes) {
        if (this._map) {
            this.setOptions();
            if (changes.dataSources) {
                this.updateDataSources();
            }
            if (changes.cursor) {
                this._map.getCanvasContainer().style.cursor = this.cursor;
            }
        }
    }
    updateDataSources() {
        let drawingToolbarSourceId = null;
        let previewToolbarSourceId = null;
        if (this.drawingToolbar) {
            drawingToolbarSourceId = this.drawingToolbar.getDatasource().getId();
            previewToolbarSourceId = this.drawingToolbar.getPreviewSource().getId();
        }
        const mapSources = this._map.sources.getSources()
            .filter(s => s.getId() !== 'vectorTiles'
            && s.getId() !== 'incidents-source'
            && (drawingToolbarSourceId && s.getId() !== drawingToolbarSourceId)
            && (previewToolbarSourceId && s.getId() !== previewToolbarSourceId))
            .map(s => s.getId());
        if ((!this.dataSources || this.dataSources.length === 0) && (mapSources && mapSources.length > 0)) {
            this._map.sources.clear();
        }
        else if (this.dataSources) {
            const dataSourcesToAdd = this.dataSources.filter(ds => ds && !this._map.sources.getById(ds.getId()));
            const dataSourcesToRemove = mapSources.filter(id => !this.dataSources.find(s => s && s.getId() === id));
            this._map.sources.add(dataSourcesToAdd);
            for (const sourceId of dataSourcesToRemove) {
                const layer = this.sourceLayers.find(l => sourceId && l.dataSourceId === sourceId);
                if (layer) {
                    layer.clear(this._map);
                }
            }
            this._map.sources.remove(dataSourcesToRemove);
        }
    }
    setOptions() {
        const cameraOptions = {
            bearing: this.bearing,
            centerOffset: this.centerOffset,
            duration: this.duration,
            maxZoom: this.maxZoom,
            minZoom: this.minZoom,
            pitch: this.pitch,
            type: this.cameraType
        };
        if (this.bounds) {
            cameraOptions.bounds = this.bounds;
            cameraOptions.maxBounds = this.maxBounds;
            cameraOptions.offset = this.offset;
            cameraOptions.padding = this.padding;
        }
        else {
            cameraOptions.center = this.center;
            cameraOptions.zoom = this.zoom;
        }
        this._map.setCamera(cameraOptions);
        this._map.setStyle({
            autoResize: this.autoResize,
            language: this.language,
            light: this.light,
            preserveDrawingBuffer: this.preserveDrawingBuffer,
            renderWorldCopies: this.renderWorldCopies,
            showBuildingModels: this.showBuildingModels,
            showFeedbackLink: this.showFeedbackLink,
            showLogo: this.showLogo,
            showTileBoundaries: this.showTilesBoundary,
            style: this.mapStyle,
            view: this.view
        });
        this._map.setUserInteraction({
            boxZoomInteraction: this.boxZoomInteraction,
            dblclickZoomInteraction: this.dblclickZoomInteraction,
            dragPanInteraction: this.dragPanInteraction,
            dragRotateInteraction: this.dragRotateInteraction,
            interactive: this.interactive,
            keyboardInteraction: this.keyboardInteraction,
            scrollZoomInteraction: this.scrollZoomInteraction,
            touchInteraction: this.touchInteraction,
            wheelZoomRate: this.wheelZoomRate
        });
        if (this.trafficOptions) {
            this._map.setTraffic(this.trafficOptions);
        }
    }
    toMapEvent(e) {
        return {
            event: e,
            map: this._map
        };
    }
}
AzureMapDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: AzureMapDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
AzureMapDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.0.1", type: AzureMapDirective, selector: "[azure-map], azure-map", inputs: { autoResize: "autoResize", bearing: "bearing", bounds: "bounds", boxZoomInteraction: "boxZoomInteraction", cameraType: "cameraType", center: "center", centerOffset: "centerOffset", cursor: "cursor", dblclickZoomInteraction: "dblclickZoomInteraction", disableTelemetry: "disableTelemetry", duration: "duration", dragPanInteraction: "dragPanInteraction", dragRotateInteraction: "dragRotateInteraction", enableAccessibility: "enableAccessibility", interactive: "interactive", keyboardInteraction: "keyboardInteraction", language: "language", light: "light", maxBounds: "maxBounds", maxZoom: "maxZoom", minZoom: "minZoom", offset: "offset", padding: "padding", preserveDrawingBuffer: "preserveDrawingBuffer", pitch: "pitch", refreshExpiredTiles: "refreshExpiredTiles", renderWorldCopies: "renderWorldCopies", scrollZoomInteraction: "scrollZoomInteraction", mapStyle: "mapStyle", showBuildingModels: "showBuildingModels", showFeedbackLink: "showFeedbackLink", showLogo: "showLogo", showTilesBoundary: "showTilesBoundary", touchInteraction: "touchInteraction", view: "view", wheelZoomRate: "wheelZoomRate", zoom: "zoom", dataSources: "dataSources", trafficOptions: "trafficOptions" }, outputs: { onBoxZoomEnd: "onBoxZoomEnd", onBoxZoomStart: "onBoxZoomStart", onClick: "onClick", onContextMenu: "onContextMenu", onData: "onData", onDblClick: "onDblClick", onDrag: "onDrag", onDragEnd: "onDragEnd", onDragStart: "onDragStart", onError: "onError", onIdle: "onIdle", onLayerAdded: "onLayerAdded", onLayerRemoved: "onLayerRemoved", onLoad: "onLoad", onMouseDown: "onMouseDown", onMouseLeave: "onMouseLeave", onMouseMove: "onMouseMove", onMouseOut: "onMouseOut", onMouseOver: "onMouseOver", onMouseUp: "onMouseUp", onMove: "onMove", onMoveEnd: "onMoveEnd", onMoveStart: "onMoveStart", onPitch: "onPitch", onPitchEnd: "onPitchEnd", onPitchStart: "onPitchStart", onReady: "onReady", onRender: "onRender", onResize: "onResize", onRotate: "onRotate", onRotateEnd: "onRotateEnd", onRotateStart: "onRotateStart", onSourceAdded: "onSourceAdded", onSourceData: "onSourceData", onSourceRemoved: "onSourceRemoved", onStyleData: "onStyleData", onStyleImageMissing: "onStyleImageMissing", onTokenAcquired: "onTokenAcquired", onTouchCancel: "onTouchCancel", onTouchEnd: "onTouchEnd", onTouchMove: "onTouchMove", onTouchStart: "onTouchStart", onWheel: "onWheel", onZoom: "onZoom", onZoomEnd: "onZoomEnd", onZoomStart: "onZoomStart" }, queries: [{ propertyName: "zoomControl", first: true, predicate: ZoomControlDirective, descendants: true }, { propertyName: "pitchControl", first: true, predicate: PitchControlDirective, descendants: true }, { propertyName: "compassControl", first: true, predicate: CompassControlDirective, descendants: true }, { propertyName: "styleControl", first: true, predicate: StyleControlDirective, descendants: true }, { propertyName: "htmlMarkers", predicate: HtmlMarkerDirective }, { propertyName: "drawingToolbar", first: true, predicate: DrawingToolbarDirective, descendants: true }, { propertyName: "symbolLayers", predicate: SymbolLayerDirective }, { propertyName: "bubbleLayers", predicate: BubbleLayerDirective }, { propertyName: "lineLayers", predicate: LineLayerDirective }, { propertyName: "polygonLayers", predicate: PolygonLayerDirective }, { propertyName: "polygonExtrusionLayers", predicate: PolygonExtrusionLayerDirective }, { propertyName: "heatmapLayers", predicate: HeatmapLayerDirective }, { propertyName: "imageLayers", predicate: ImageLayerDirective }, { propertyName: "tileLayers", predicate: TileLayerDirective }, { propertyName: "popups", predicate: PopupDirective }], usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: AzureMapDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[azure-map], azure-map',
                    queries: {
                        zoomControl: new ContentChild(ZoomControlDirective),
                        pitchControl: new ContentChild(PitchControlDirective),
                        compassControl: new ContentChild(CompassControlDirective),
                        styleControl: new ContentChild(StyleControlDirective),
                        htmlMarkers: new ContentChildren(HtmlMarkerDirective),
                        drawingToolbar: new ContentChild(DrawingToolbarDirective),
                        symbolLayers: new ContentChildren(SymbolLayerDirective),
                        bubbleLayers: new ContentChildren(BubbleLayerDirective),
                        lineLayers: new ContentChildren(LineLayerDirective),
                        polygonLayers: new ContentChildren(PolygonLayerDirective),
                        polygonExtrusionLayers: new ContentChildren(PolygonExtrusionLayerDirective),
                        heatmapLayers: new ContentChildren(HeatmapLayerDirective),
                        imageLayers: new ContentChildren(ImageLayerDirective),
                        tileLayers: new ContentChildren(TileLayerDirective),
                        popups: new ContentChildren(PopupDirective)
                    }
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { autoResize: [{
                type: Input
            }], bearing: [{
                type: Input
            }], bounds: [{
                type: Input
            }], boxZoomInteraction: [{
                type: Input
            }], cameraType: [{
                type: Input
            }], center: [{
                type: Input
            }], centerOffset: [{
                type: Input
            }], cursor: [{
                type: Input
            }], dblclickZoomInteraction: [{
                type: Input
            }], disableTelemetry: [{
                type: Input
            }], duration: [{
                type: Input
            }], dragPanInteraction: [{
                type: Input
            }], dragRotateInteraction: [{
                type: Input
            }], enableAccessibility: [{
                type: Input
            }], interactive: [{
                type: Input
            }], keyboardInteraction: [{
                type: Input
            }], language: [{
                type: Input
            }], light: [{
                type: Input
            }], maxBounds: [{
                type: Input
            }], maxZoom: [{
                type: Input
            }], minZoom: [{
                type: Input
            }], offset: [{
                type: Input
            }], padding: [{
                type: Input
            }], preserveDrawingBuffer: [{
                type: Input
            }], pitch: [{
                type: Input
            }], refreshExpiredTiles: [{
                type: Input
            }], renderWorldCopies: [{
                type: Input
            }], scrollZoomInteraction: [{
                type: Input
            }], mapStyle: [{
                type: Input
            }], showBuildingModels: [{
                type: Input
            }], showFeedbackLink: [{
                type: Input
            }], showLogo: [{
                type: Input
            }], showTilesBoundary: [{
                type: Input
            }], touchInteraction: [{
                type: Input
            }], view: [{
                type: Input
            }], wheelZoomRate: [{
                type: Input
            }], zoom: [{
                type: Input
            }], dataSources: [{
                type: Input
            }], trafficOptions: [{
                type: Input
            }], onBoxZoomEnd: [{
                type: Output
            }], onBoxZoomStart: [{
                type: Output
            }], onClick: [{
                type: Output
            }], onContextMenu: [{
                type: Output
            }], onData: [{
                type: Output
            }], onDblClick: [{
                type: Output
            }], onDrag: [{
                type: Output
            }], onDragEnd: [{
                type: Output
            }], onDragStart: [{
                type: Output
            }], onError: [{
                type: Output
            }], onIdle: [{
                type: Output
            }], onLayerAdded: [{
                type: Output
            }], onLayerRemoved: [{
                type: Output
            }], onLoad: [{
                type: Output
            }], onMouseDown: [{
                type: Output
            }], onMouseLeave: [{
                type: Output
            }], onMouseMove: [{
                type: Output
            }], onMouseOut: [{
                type: Output
            }], onMouseOver: [{
                type: Output
            }], onMouseUp: [{
                type: Output
            }], onMove: [{
                type: Output
            }], onMoveEnd: [{
                type: Output
            }], onMoveStart: [{
                type: Output
            }], onPitch: [{
                type: Output
            }], onPitchEnd: [{
                type: Output
            }], onPitchStart: [{
                type: Output
            }], onReady: [{
                type: Output
            }], onRender: [{
                type: Output
            }], onResize: [{
                type: Output
            }], onRotate: [{
                type: Output
            }], onRotateEnd: [{
                type: Output
            }], onRotateStart: [{
                type: Output
            }], onSourceAdded: [{
                type: Output
            }], onSourceData: [{
                type: Output
            }], onSourceRemoved: [{
                type: Output
            }], onStyleData: [{
                type: Output
            }], onStyleImageMissing: [{
                type: Output
            }], onTokenAcquired: [{
                type: Output
            }], onTouchCancel: [{
                type: Output
            }], onTouchEnd: [{
                type: Output
            }], onTouchMove: [{
                type: Output
            }], onTouchStart: [{
                type: Output
            }], onWheel: [{
                type: Output
            }], onZoom: [{
                type: Output
            }], onZoomEnd: [{
                type: Output
            }], onZoomStart: [{
                type: Output
            }] } });

const searchAddressOptionalParamsToQueryString = (params) => {
    if (!params) {
        return '';
    }
    const queryStringParameters = [];
    if (params.btmRight) {
        queryStringParameters.push(`btmRight=${params.btmRight[0]},${params.btmRight[1]}`);
    }
    if (params.countrySet) {
        queryStringParameters.push(`countrySet=${params.countrySet.join(',')}`);
    }
    if (params.extendedPostalCodesFor) {
        queryStringParameters.push(`extendedPostalCodesFor=${params.extendedPostalCodesFor.map(pc => pc.toString()).join(',')}`);
    }
    if (params.language) {
        queryStringParameters.push(`language=${params.language}`);
    }
    if (params.lat) {
        queryStringParameters.push(`lat=${params.lat}`);
    }
    if (params.limit) {
        queryStringParameters.push(`limit=${params.limit}`);
    }
    if (params.lon) {
        queryStringParameters.push(`lon=${params.lon}`);
    }
    if (params.ofs) {
        queryStringParameters.push(`ofs=${params.ofs}`);
    }
    if (params.radius) {
        queryStringParameters.push(`radius=${params.radius}`);
    }
    if (params.topLeft) {
        queryStringParameters.push(`topLeft=${params.topLeft[0]},${params.topLeft[1]}`);
    }
    if (params.typeahead !== null && params.typeahead !== undefined) {
        queryStringParameters.push(`typeahead=${params.typeahead ? 1 : 0}`);
    }
    if (params.view) {
        queryStringParameters.push(`view=${params.view}`);
    }
    return queryStringParameters.join('&');
};

var RoadUse;
(function (RoadUse) {
    RoadUse["LimitedAccess"] = "LimitedAccess";
    RoadUse["Arterial"] = "Arterial";
    RoadUse["Terminal"] = "Terminal";
    RoadUse["Ramp"] = "Ramp";
    RoadUse["Rotary"] = "Rotary";
    RoadUse["LocalStreet"] = "LocalStreet";
})(RoadUse || (RoadUse = {}));
const searchAddressReverseOptionalParamsToQueryString = (options) => {
    if (!options) {
        return '';
    }
    const queryParameters = [];
    if (options.allowFreeformNewline !== null && options.allowFreeformNewline !== undefined) {
        queryParameters.push(`allowFreeformNewline=${options.allowFreeformNewline.toString()}`);
    }
    if (options.entityType) {
        queryParameters.push(`entityType=${options.entityType.toString()}`);
    }
    if (options.heading) {
        queryParameters.push(`heading=${options.heading}`);
    }
    if (options.language) {
        queryParameters.push(`language=${options.language}`);
    }
    if (options.number) {
        queryParameters.push(`number=${options.number}`);
    }
    if (options.radius) {
        queryParameters.push(`radius=${options.radius}`);
    }
    if (options.returnMatchType !== null && options.returnMatchType !== undefined) {
        queryParameters.push(`returnMatchType=${options.returnMatchType.toString()}`);
    }
    if (options.returnRoadUse !== null && options.returnRoadUse !== undefined) {
        queryParameters.push(`returnRoadUse=${options.returnRoadUse.toString()}`);
    }
    if (options.returnSpeedLimit !== null && options.returnSpeedLimit !== undefined) {
        queryParameters.push(`returnSpeedLimit=${options.returnSpeedLimit.toString()}`);
    }
    if (options.roadUse) {
        queryParameters.push(`roadUse=${options.roadUse.join(',')}`);
    }
    return queryParameters.join('&');
};

const searchAddressReverseCrossStreetOptionalParamsToQueryString = (options) => {
    if (!options) {
        return '';
    }
    const queryParameters = [];
    if (options.heading) {
        queryParameters.push(`heading=${options.heading}`);
    }
    if (options.language) {
        queryParameters.push(`language=${options.language}`);
    }
    if (options.limit) {
        queryParameters.push(`limit=${options.limit}`);
    }
    if (options.radius) {
        queryParameters.push(`radius=${options.radius}`);
    }
    if (options.view) {
        queryParameters.push(`view=${options.view}`);
    }
    return queryParameters.join('&');
};

var ExtendedPostalCodes;
(function (ExtendedPostalCodes) {
    ExtendedPostalCodes["AddressRanges"] = "Addr";
    ExtendedPostalCodes["Geographies"] = "Geo";
    ExtendedPostalCodes["PointAddresses"] = "PAD";
    ExtendedPostalCodes["PointOfIntereset"] = "POI";
    ExtendedPostalCodes["Streets"] = "Str";
    ExtendedPostalCodes["CrossStreets"] = "XStr";
})(ExtendedPostalCodes || (ExtendedPostalCodes = {}));

const searchAddressStructuredOptionalParamsToQueryString = (options) => {
    if (!options) {
        return '';
    }
    const queryParameters = [];
    if (options.countrySecondarySubdivision) {
        queryParameters.push(`countrySecondarySubdivision=${options.countrySecondarySubdivision}`);
    }
    if (options.countrySubdivision) {
        queryParameters.push(`countrySubdivision=${options.countrySubdivision}`);
    }
    if (options.countryTertiarySubdivision) {
        queryParameters.push(`countryTertiarySubdivision=${options.countryTertiarySubdivision}`);
    }
    if (options.crossStreet) {
        queryParameters.push(`crossStreet=${options.crossStreet}`);
    }
    if (options.extendedPostalCodesFor) {
        queryParameters.push(`extendedPostalCodesFor=${options.extendedPostalCodesFor.map(pc => pc.toString()).join(',')}`);
    }
    if (options.language) {
        queryParameters.push(`language=${options.language}`);
    }
    if (options.limit) {
        queryParameters.push(`limit=${options.limit}`);
    }
    if (options.municipality) {
        queryParameters.push(`municipality=${options.municipality}`);
    }
    if (options.municipalitySubdivision) {
        queryParameters.push(`municipalitySubdivision=${options.municipalitySubdivision}`);
    }
    if (options.ofs) {
        queryParameters.push(`ofs=${options.ofs}`);
    }
    if (options.postalCode) {
        queryParameters.push(`postalCode=${options.postalCode}`);
    }
    if (options.streetName) {
        queryParameters.push(`streetName=${options.streetName}`);
    }
    if (options.streetNumber) {
        queryParameters.push(`streetNumber=${options.streetNumber}`);
    }
    if (options.view) {
        queryParameters.push(`view=${options.view}`);
    }
    return queryParameters.join('&');
};

var ConnectorSet;
(function (ConnectorSet) {
    /**
     * These are the standard household connectors for a certain region. They are all AC single phase and the standard Voltage and standard Amperage
     */
    ConnectorSet["StandardHouseholdCountrySpecific"] = "StandardHouseholdCountrySpecific";
    /**
     * Type 1 connector as defined in the IEC 62196-2 standard. Also called Yazaki after the original manufacturer or SAE J1772 after the standard that first published it. Mostly used in combination with 120V single phase or up to 240V single phase infrastructure.
     */
    ConnectorSet["IEC62196Type1"] = "IEC62196Type1";
    /**
     * Type 1 based combo connector as defined in the IEC 62196-3 standard. The connector is based on the Type 1 connector – as defined in the IEC 62196-2 standard – with two additional direct current (DC) contacts to allow DC fast charging.
     */
    ConnectorSet["IEC62196Type1CCS"] = "IEC62196Type1CCS";
    /**
     * Type 2 connector as defined in the IEC 62196-2 standard. Provided as a cable and plug attached to the charging point.
     */
    ConnectorSet["IEC62196Type2CableAttached"] = "IEC62196Type2CableAttached";
    /**
     * Type 2 connector as defined in the IEC 62196-2 standard. Provided as a socket set into the charging point.
     */
    ConnectorSet["IEC62196Type2Outlet"] = "IEC62196Type2Outlet";
    /**
     *  Type 2 based combo connector as defined in the IEC 62196-3 standard. The connector is based on the Type 2 connector – as defined in the IEC 62196-2 standard – with two additional direct current (DC) contacts to allow DC fast charging.
     */
    ConnectorSet["IEC62196Type2CCS"] = "IEC62196Type2CCS";
    /**
     * Type 3 connector as defined in the IEC 62196-2 standard. Also called Scame after the original manufacturer. Mostly used in combination with up to 240V single phase or up to 420V three phase infrastructure.
     */
    ConnectorSet["IEC62196Type3"] = "IEC62196Type3";
    /**
     * CHAdeMO connector named after an association formed by the Tokyo Electric Power Company and industrial partners. Because of this is is also known as the TEPCO's connector. It supports fast DC charging.
     */
    ConnectorSet["Chademo"] = "Chademo";
    /**
     * Industrial Blue connector is a connector defined in the IEC 60309 standard. It is sometime referred to as by some combination of the standard, the color and the fact that is a single phase connector. The connector usually has the "P+N+E, 6h" configuration.
     */
    ConnectorSet["IEC60309AC1PhaseBlue"] = "IEC60309AC1PhaseBlue";
    /**
     * Industrial White connector is a DC connector defined in the IEC 60309 standard.
     */
    ConnectorSet["IEC60309DCWhite"] = "IEC60309DCWhite";
    /**
     * The Tesla connector is the regionally specific Tesla Supercharger connector. I.e. it refers to either Tesla's proprietary connector, sometimes referred to as Tesla Port mostly limited to North America or the modified Type 2 (DC over Type 2) in Europe.
     */
    ConnectorSet["Tesla"] = "Tesla";
})(ConnectorSet || (ConnectorSet = {}));

const searchFuzzyOptionalParamsToQueryString = (options) => {
    if (!options) {
        return '';
    }
    const queryParameters = [];
    if (options.brandSet) {
        queryParameters.push(`brandSet=${options.brandSet.join(',')}`);
    }
    if (options.btmRight) {
        queryParameters.push(`btmRight=${options.btmRight}`);
    }
    if (options.categorySet) {
        queryParameters.push(`categorySet=${options.categorySet.join(',')}`);
    }
    if (options.connectorSet) {
        queryParameters.push(`connectorSet=${options.connectorSet.map(cs => cs.toString()).join(',')}`);
    }
    if (options.countrySet) {
        queryParameters.push(`countrySet=${options.countrySet.join(',')}`);
    }
    if (options.extendedPostalCodesFor) {
        queryParameters.push(`extendedPostalCodesFor=${options.extendedPostalCodesFor.map(epc => epc.toString()).join(',')}`);
    }
    if (options.idxSet) {
        queryParameters.push(`idxSet=${options.idxSet.map(id => id.toString()).join(',')}`);
    }
    if (options.language) {
        queryParameters.push(`language=${options.language}`);
    }
    if (options.lat) {
        queryParameters.push(`lat=${options.lat}`);
    }
    if (options.limit) {
        queryParameters.push(`limit=${options.limit}`);
    }
    if (options.lon) {
        queryParameters.push(`lon=${options.lon}`);
    }
    if (options.maxFuzzyLevel) {
        queryParameters.push(`maxFuzzyLevel=${options.maxFuzzyLevel}`);
    }
    if (options.minFuzzyLevel) {
        queryParameters.push(`minFuzzyLevel=${options.minFuzzyLevel}`);
    }
    if (options.ofs) {
        queryParameters.push(`ofs=${options.ofs}`);
    }
    if (options.openingHours) {
        queryParameters.push(`openingHours=${options.openingHours}`);
    }
    if (options.radius) {
        queryParameters.push(`radius=${options.radius}`);
    }
    if (options.topLeft) {
        queryParameters.push(`topLeft=${options.topLeft}`);
    }
    if (options.typeahead) {
        queryParameters.push(`typeahead=${options.typeahead}`);
    }
    if (options.view) {
        queryParameters.push(`view=${options.view}`);
    }
    return queryParameters.join('&');
};

const searchNearbyOptionalParamsToQueryString = (options) => {
    if (!options) {
        return '';
    }
    const queryParameters = [];
    if (options.brandSet) {
        queryParameters.push(`brandSet=${options.brandSet.join(',')}`);
    }
    if (options.categorySet) {
        queryParameters.push(`categorySet=${options.categorySet.join(',')}`);
    }
    if (options.connectorSet) {
        queryParameters.push(`connectorSet=${options.connectorSet.map(cs => cs.toString()).join(',')}`);
    }
    if (options.countrySet) {
        queryParameters.push(`countrySet=${options.countrySet.join(',')}`);
    }
    if (options.extendedPostalCodesFor) {
        queryParameters.push(`extendedPostalCodesFor=${options.extendedPostalCodesFor.map(epc => epc.toString()).join(',')}`);
    }
    if (options.language) {
        queryParameters.push(`language=${options.language}`);
    }
    if (options.limit) {
        queryParameters.push(`limit=${options.limit}`);
    }
    if (options.ofs) {
        queryParameters.push(`ofs=${options.ofs}`);
    }
    if (options.radius) {
        queryParameters.push(`radius=${options.radius}`);
    }
    if (options.view) {
        queryParameters.push(`view=${options.view}`);
    }
    return queryParameters.join('&');
};

const searchPOIOptionalParamsToQueryString = (options) => {
    if (!options) {
        return '';
    }
    const queryParameters = [];
    if (options.brandSet) {
        queryParameters.push(`brandSet=${options.brandSet.join(',')}`);
    }
    if (options.btmRight) {
        queryParameters.push(`btmRight=${options.btmRight}`);
    }
    if (options.categorySet) {
        queryParameters.push(`categorySet=${options.categorySet.join(',')}`);
    }
    if (options.connectorSet) {
        queryParameters.push(`connectorSet=${options.connectorSet.map(cs => cs.toString()).join(',')}`);
    }
    if (options.countrySet) {
        queryParameters.push(`countrySet=${options.countrySet.join(',')}`);
    }
    if (options.extendedPostalCodesFor) {
        queryParameters.push(`extendedPostalCodesFor=${options.extendedPostalCodesFor.map(epc => epc.toString()).join(',')}`);
    }
    if (options.language) {
        queryParameters.push(`language=${options.language}`);
    }
    if (options.lat) {
        queryParameters.push(`lat=${options.lat}`);
    }
    if (options.limit) {
        queryParameters.push(`limit=${options.limit}`);
    }
    if (options.lon) {
        queryParameters.push(`lon=${options.lon}`);
    }
    if (options.ofs) {
        queryParameters.push(`ofs=${options.ofs}`);
    }
    if (options.openingHours) {
        queryParameters.push(`openingHours=${options.openingHours}`);
    }
    if (options.radius) {
        queryParameters.push(`radius=${options.radius}`);
    }
    if (options.topLeft) {
        queryParameters.push(`topLeft=${options.topLeft}`);
    }
    if (options.typeahead) {
        queryParameters.push(`typeahead=${options.typeahead}`);
    }
    if (options.view) {
        queryParameters.push(`view=${options.view}`);
    }
    return queryParameters.join('&');
};

const searchPOICategoryOptionalParamsToQueryString = (options) => {
    if (!options) {
        return '';
    }
    const queryParameters = [];
    if (options.brandSet) {
        queryParameters.push(`brandSet=${options.brandSet.join(',')}`);
    }
    if (options.btmRight) {
        queryParameters.push(`btmRight=${options.btmRight}`);
    }
    if (options.categorySet) {
        queryParameters.push(`categorySet=${options.categorySet.join(',')}`);
    }
    if (options.connectorSet) {
        queryParameters.push(`connectorSet=${options.connectorSet.map(cs => cs.toString()).join(',')}`);
    }
    if (options.countrySet) {
        queryParameters.push(`countrySet=${options.countrySet.join(',')}`);
    }
    if (options.extendedPostalCodesFor) {
        queryParameters.push(`extendedPostalCodesFor=${options.extendedPostalCodesFor.map(epc => epc.toString()).join(',')}`);
    }
    if (options.language) {
        queryParameters.push(`language=${options.language}`);
    }
    if (options.lat) {
        queryParameters.push(`lat=${options.lat}`);
    }
    if (options.limit) {
        queryParameters.push(`limit=${options.limit}`);
    }
    if (options.lon) {
        queryParameters.push(`lon=${options.lon}`);
    }
    if (options.ofs) {
        queryParameters.push(`ofs=${options.ofs}`);
    }
    if (options.openingHours) {
        queryParameters.push(`openingHours=${options.openingHours}`);
    }
    if (options.radius) {
        queryParameters.push(`radius=${options.radius}`);
    }
    if (options.topLeft) {
        queryParameters.push(`topLeft=${options.topLeft}`);
    }
    if (options.typeahead) {
        queryParameters.push(`typeahead=${options.typeahead}`);
    }
    if (options.view) {
        queryParameters.push(`view=${options.view}`);
    }
    return queryParameters.join('&');
};

const searchPOICategoryTreeOptionalParamsToQueryString = (options) => {
    if (!options && !options.language) {
        return '';
    }
    return `language=${options.language}`;
};

const searchAlongRouteOptionalParamsToQueryString = (options) => {
    if (!options) {
        return '';
    }
    const queryParameters = [];
    if (options.brandSet) {
        queryParameters.push(`brandSet=${options.brandSet.join(',')}`);
    }
    if (options.categorySet) {
        queryParameters.push(`categorySet=${options.categorySet.join(',')}`);
    }
    if (options.connectorSet) {
        queryParameters.push(`connectorSet=${options.connectorSet.map(cs => cs.toString()).join(',')}`);
    }
    if (options.limit) {
        queryParameters.push(`limit=${options.limit}`);
    }
    if (options.openingHours) {
        queryParameters.push(`openingHours=${options.openingHours}`);
    }
    if (options.view) {
        queryParameters.push(`view=${options.view}`);
    }
    return queryParameters.join('&');
};

const searchInsideGeometryOptionalParamsToQueryString = (options) => {
    if (!options) {
        return '';
    }
    const queryParameters = [];
    if (options.categorySet) {
        queryParameters.push(`categorySet=${options.categorySet.join(',')}`);
    }
    if (options.extendedPostalCodesFor) {
        queryParameters.push(`extendedPostalCodesFor=${options.extendedPostalCodesFor.map(epc => epc.toString()).join(',')}`);
    }
    if (options.idxSet) {
        queryParameters.push(`idxSet=${options.idxSet.map(id => id.toString()).join(',')}`);
    }
    if (options.language) {
        queryParameters.push(`language=${options.language}`);
    }
    if (options.limit) {
        queryParameters.push(`limit=${options.limit}`);
    }
    if (options.openingHours) {
        queryParameters.push(`openingHours=${options.openingHours}`);
    }
    if (options.view) {
        queryParameters.push(`view=${options.view}`);
    }
    return queryParameters.join('&');
};

/**
 * Using the AAD Authentication, the azure-maps-controls library seems to be based on ADAL. This will break if the switch to MSAL is done.
 */
const atlasAccessTokenStorageKey = 'adal.access.token.keyhttps://atlas.microsoft.com/';
const getAtlasToken = () => localStorage.getItem(atlasAccessTokenStorageKey);

class AtlasRestAuthenticationInterceptor {
    constructor(azureMapsConfiguration) {
        this.azureMapsConfiguration = azureMapsConfiguration;
    }
    intercept(req, next) {
        if (req.url.startsWith('https://atlas.microsoft.com')) {
            if (this.azureMapsConfiguration.authOptions.authType === atlas.AuthenticationType.subscriptionKey) {
                const skClone = req.clone({
                    url: req.urlWithParams + `&subscription-key=${this.azureMapsConfiguration.authOptions.subscriptionKey}`
                });
                return next.handle(skClone);
            }
            if (this.azureMapsConfiguration.authOptions.authType === atlas.AuthenticationType.aad) {
                const aadClone = req.clone({
                    setHeaders: {
                        'x-ms-client-id': this.azureMapsConfiguration.authOptions.clientId,
                        authorization: `Bearer ${getAtlasToken()}`
                    }
                });
                return next.handle(aadClone);
            }
        }
        return next.handle(req);
    }
}
AtlasRestAuthenticationInterceptor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: AtlasRestAuthenticationInterceptor, deps: [{ token: AZUREMAPS_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable });
AtlasRestAuthenticationInterceptor.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: AtlasRestAuthenticationInterceptor });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: AtlasRestAuthenticationInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: function () {
        return [{ type: AzureMapsConfiguration, decorators: [{
                        type: Inject,
                        args: [AZUREMAPS_CONFIG]
                    }] }];
    } });

const setAzureMapsConfiguration = (configuration) => {
    if (!configuration) {
        throw Error('No AzureMapsConfiguration was provided');
    }
    atlas.setAuthenticationOptions(configuration.authOptions);
    if (configuration.domain) {
        atlas.setDomain(configuration.domain);
    }
};
const setAtlasOptions = (configuration) => () => new Promise(resolve => {
    if (configuration) {
        setAzureMapsConfiguration(configuration);
    }
    resolve();
});
//@dynamic
class AzureMapsModule {
    static forRoot(configuration) {
        return {
            ngModule: AzureMapsModule,
            providers: [
                {
                    provide: AZUREMAPS_CONFIG,
                    useValue: configuration
                },
                {
                    provide: APP_INITIALIZER,
                    useFactory: setAtlasOptions,
                    deps: [AZUREMAPS_CONFIG],
                    multi: true
                },
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: AtlasRestAuthenticationInterceptor,
                    multi: true
                }
            ]
        };
    }
    static forChild(configuration) {
        setAzureMapsConfiguration(configuration);
        return {
            ngModule: AzureMapsModule,
            providers: [
                {
                    provide: AZUREMAPS_CONFIG,
                    useValue: configuration
                },
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: AtlasRestAuthenticationInterceptor,
                    multi: true
                }
            ]
        };
    }
}
AzureMapsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: AzureMapsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AzureMapsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: AzureMapsModule, declarations: [AzureMapDirective,
        ZoomControlDirective,
        PitchControlDirective,
        CompassControlDirective,
        StyleControlDirective,
        HtmlMarkerDirective,
        DrawingToolbarDirective,
        SymbolLayerDirective,
        BubbleLayerDirective,
        LineLayerDirective,
        PolygonLayerDirective,
        PolygonExtrusionLayerDirective,
        HeatmapLayerDirective,
        ImageLayerDirective,
        TileLayerDirective,
        PopupDirective], imports: [HttpClientModule], exports: [AzureMapDirective,
        ZoomControlDirective,
        PitchControlDirective,
        CompassControlDirective,
        StyleControlDirective,
        HtmlMarkerDirective,
        DrawingToolbarDirective,
        SymbolLayerDirective,
        BubbleLayerDirective,
        LineLayerDirective,
        PolygonLayerDirective,
        PolygonExtrusionLayerDirective,
        HeatmapLayerDirective,
        ImageLayerDirective,
        TileLayerDirective,
        PopupDirective] });
AzureMapsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: AzureMapsModule, imports: [[
            HttpClientModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: AzureMapsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        AzureMapDirective,
                        ZoomControlDirective,
                        PitchControlDirective,
                        CompassControlDirective,
                        StyleControlDirective,
                        HtmlMarkerDirective,
                        DrawingToolbarDirective,
                        SymbolLayerDirective,
                        BubbleLayerDirective,
                        LineLayerDirective,
                        PolygonLayerDirective,
                        PolygonExtrusionLayerDirective,
                        HeatmapLayerDirective,
                        ImageLayerDirective,
                        TileLayerDirective,
                        PopupDirective
                    ],
                    exports: [
                        AzureMapDirective,
                        ZoomControlDirective,
                        PitchControlDirective,
                        CompassControlDirective,
                        StyleControlDirective,
                        HtmlMarkerDirective,
                        DrawingToolbarDirective,
                        SymbolLayerDirective,
                        BubbleLayerDirective,
                        LineLayerDirective,
                        PolygonLayerDirective,
                        PolygonExtrusionLayerDirective,
                        HeatmapLayerDirective,
                        ImageLayerDirective,
                        TileLayerDirective,
                        PopupDirective
                    ],
                    imports: [
                        HttpClientModule
                    ]
                }]
        }] });

class PipelineProvider {
    constructor(azureMapsConfiguration) {
        this.azureMapsConfiguration = azureMapsConfiguration;
    }
    getPipeline() {
        if (this.azureMapsConfiguration.authOptions.authType === AuthenticationType.subscriptionKey) {
            return atlas$1.MapsURL.newPipeline(new atlas$1.SubscriptionKeyCredential(this.azureMapsConfiguration.authOptions.subscriptionKey), {
                retryOptions: this.azureMapsConfiguration.pipelineRetryOptions
            });
        }
        if (this.azureMapsConfiguration.authOptions.authType === AuthenticationType.aad) {
            return atlas$1.MapsURL.newPipeline(new atlas$1.TokenCredential(this.azureMapsConfiguration.authOptions.clientId, getAtlasToken()), {
                retryOptions: this.azureMapsConfiguration.pipelineRetryOptions
            });
        }
        throw new Error('Authentication type not supported');
    }
}
PipelineProvider.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: PipelineProvider, deps: [{ token: AZUREMAPS_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable });
PipelineProvider.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: PipelineProvider, providedIn: AzureMapsModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: PipelineProvider, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: AzureMapsModule
                }]
        }], ctorParameters: function () {
        return [{ type: AzureMapsConfiguration, decorators: [{
                        type: Inject,
                        args: [AZUREMAPS_CONFIG]
                    }] }];
    } });

class AtlasHttpService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this._rootUrl = 'https://atlas.microsoft.com';
        this._apiVersion = '1.0';
    }
    buildUrl(path) {
        return `${this._rootUrl}/${path}?api-version=${this._apiVersion}`;
    }
}

class SearchService extends AtlasHttpService {
    constructor(httpClient) {
        super(httpClient);
    }
    /**
     *
     *
     * **Address Geocoding** In many cases, the complete search service might be too much, for
     *
     * instance if you are only interested in traditional geocoding.
     *
     * Search can also be accessed for address look up exclusively.
     *
     * The geocoding is performed by hitting the geocode endpoint with just the address or
     *
     * partial address in question.
     *
     * The geocoding search index will be queried for everything above the street level data.
     *
     * No POIs will be returned.
     *
     * Note that the geocoder is very tolerant of typos and incomplete addresses.
     *
     * It will also handle everything from exact street addresses or street or intersections
     *
     * as well as higher level geographies such as city centers, counties, states etc.
     *
     * Uses the Get Search Address API: https://docs.microsoft.com/rest/api/maps/search/getsearchaddress
     *
     *
     *
     * @param query The address to search for (e.g., "1 Microsoft way, Redmond, WA").
     * @param [options] The optional parameters
     * @returns
     * @memberof SearchService
     */
    searchAddress(query, options) {
        let url = this.buildUrl('search/address/json');
        url += `&query=${query}`;
        if (options) {
            url += `&${searchAddressOptionalParamsToQueryString(options)}`;
        }
        return this.httpClient.get(url);
    }
    /**
     *
     *
     * **Reverse Geocode to an Address** There may be times when you need to translate a
     *
     * coordinate (example: -122.3862, 37.786505) into a human understandable street address.
     *
     * Most often this is needed in tracking applications where you receive a GPS feed from the device or
     *
     * asset and wish to know what address where the coordinate is located.
     *
     * This endpoint will return address information for a given coordinate.
     *
     * Uses the Get Search Address Reverse API: https://docs.microsoft.com/rest/api/maps/search/getsearchaddressreverse
     *
     * @param position The position to reverse search,
     * a coordinate array of `[longitude, latitude]` e.g. `[-122.125679, 47.641268]`.
     * @param [options] The optional parameters
     * @param timeout Create a new Aborter instance with the given timeout (in ms).
     * @returns
     * @memberof SearchService
     */
    searchAddressReverse(position, options) {
        let url = this.buildUrl('search/address/reverse/json');
        url += `&query=${position[0]},${position[1]}`;
        if (options) {
            url += `&${searchAddressReverseOptionalParamsToQueryString(options)}`;
        }
        return this.httpClient.get(url);
    }
    /**
     *
     *
     * **Reverse Geocode to a Cross Street** There may be times when you need to translate a
     *
     * coordinate (example: -122.3862, 37.786505) into a human understandable cross street.
     *
     * Most often this is needed in tracking applications where you receive a GPS feed from the device or asset
     *
     * and wish to know what address where the coordinate is located.
     *
     * This endpoint will return cross street information for a given coordinate.
     *
     * Uses the Get Search Address Reverse Cross Street API: https://docs.microsoft.com/rest/api/maps/search/getsearchaddressreversecrossstreet
     *
     * @param position The position to reverse search,
     * a coordinate array of `[longitude, latitude]` e.g. `[-122.125679, 47.641268]`.
     * @param [options] The optional parameters
     * @returns
     * @memberof SearchService
     */
    searchAddressReverseCrossStreet(position, options) {
        let url = this.buildUrl('search/address/reverse/crossStreet/json');
        url += `&query=${position[0]},${position[1]}`;
        if (options) {
            url += `&${searchAddressReverseCrossStreetOptionalParamsToQueryString(options)}`;
        }
        return this.httpClient.get(url);
    }
    /**
     *
     *
     * **Structured Address Geocoding** Azure Address Geocoding can also be accessed for
     *
     * structured address look up exclusively.
     *
     * The geocoding search index will be queried for everything above the street level data.
     *
     * No POIs will be returned. Note that the geocoder is very tolerant of typos and incomplete addresses.
     *
     * It will also handle everything from exact street addresses or street or intersections as well as
     *
     * higher level geographies such as city centers, counties, states etc.
     *
     * Uses the Get Search Address Structured API: https://docs.microsoft.com/rest/api/maps/search/getsearchaddressstructured
     *
     *
     *
     * @param countryCode The 2 or 3 letter
     * [ISO3166-1](https://www.iso.org/iso-3166-country-codes.html) country code portion of an address.
     * E.g. US.
     * @param [options] The optional parameters
     * @returns
     * @memberof SearchService
     */
    searchAddressStructured(countryCode, options) {
        let url = this.buildUrl('search/address/structured/json');
        url += `&countryCode=${countryCode}`;
        if (options) {
            url += `&${searchAddressStructuredOptionalParamsToQueryString(options)}`;
        }
        return this.httpClient.get(url);
    }
    /**
     *
     *
     * The Search Along Route endpoint allows you to perform a fuzzy search for POIs along a specified
     *
     * route.
     *
     * This search is constrained by specifying the `maxDetourTime` limiting measure.
     *
     * To send the route-points you will use a `body` which will contain the `route` object represented
     *
     * as a `GeoJSON LineString` type and the `Content-Type` header will be set to `application/json`.
     *
     * Each route-point in `route` is represented as a `GeoJSON Position` type i.e. an array where the
     *
     * _longitude_ value is followed by the _latitude_ value and the _altitude_ value is ignored.
     *
     * The `route` should contain at least 2 route-points.
     *
     * It is possible that original route will be altered, some of it's points may be skipped.
     *
     * If the route that passes through the found point is faster than the original one, the `detourTime` value in
     *
     * the response is negative.
     *
     * Uses the Post Search Along Route API: https://docs.microsoft.com/rest/api/maps/search/postsearchalongroute
     *
     *
     *
     * @param query The POI name to search for (e.g., "statue of liberty", "starbucks", "pizza").
     * @param maxDetourTime Maximum detour time of the point of interest in seconds. Max value is 3600 seconds
     * @param body This represents the route to search along and should be a
     * valid `GeoJSON LineString` type. Please refer to [RFC
     * 7946](https://tools.ietf.org/html/rfc7946#section-3.1.4) for details.
     * @param [options] The optional parameters
     * @returns
     * @memberof SearchService
     */
    searchAlongRoute(query, maxDetourTime, body, options) {
        let url = this.buildUrl('search/alongRoute/json');
        url += `&query=${query}&maxDetourTime=${maxDetourTime}`;
        if (options) {
            url += `&${searchAlongRouteOptionalParamsToQueryString(options)}`;
        }
        return this.httpClient.post(url, body);
    }
    /**
     *
     *
     * **Free Form Search** The basic default API is Free Form Search which handles the most
     *
     * fuzzy of inputs handling any combination of address or POI tokens.
     *
     * This search API is the canonical 'single line search'.
     *
     * The Free Form Search API is a seamless combination of POI search and geocoding.
     *
     * The API can also be weighted with a contextual position (lat./lon. pair), or
     *
     * fully constrained by a coordinate and radius, or it can be executed more generally without any
     *
     * geo biasing anchor point.
     *
     * We strongly advise you to use the 'countrySet' parameter to specify only the countries for
     *
     * which your application needs coverage, as the default behavior will be to search the entire world,
     *
     * potentially returning unnecessary results. E.g.: `countrySet`=US,FR. Please see [Search Coverage]
     *
     * (https://docs.microsoft.com/azure/location-based-services/geocoding-coverage) for
     *
     * a complete list of all the supported countries.
     *
     * Most Search queries default to `maxFuzzyLevel`=2 to gain performance and also reduce unusual results.
     *
     * This new default can be overridden as needed per request by passing in the query param `maxFuzzyLevel`=3 or 4.
     *
     * Uses the Get Search Fuzzy API: https://docs.microsoft.com/rest/api/maps/search/getsearchfuzzy
     *
     *
     *
     * @param query The applicable query string (e.g., "seattle", "pizza").
     * Can _also_ be specified as a coordinate array of `[longitude, latitude]` (e.g., `[-122.125679, 47.641268]`).
     * @param [options] The optional parameters
     * @returns
     * @memberof SearchService
     */
    searchFuzzy(query, options) {
        let url = this.buildUrl('search/fuzzy/json');
        if (typeof query === 'string') {
            url += `&query=${query}`;
        }
        else {
            url += `&query=${query[0]},${query[1]}`;
        }
        if (options) {
            url += `&${searchFuzzyOptionalParamsToQueryString(options)}`;
        }
        return this.httpClient.get(url);
    }
    /**
     *
     *
     * The Search Geometry endpoint allows you to perform a free form search inside a single geometry
     *
     * or many of them.
     *
     * The search results that fall inside the geometry/geometries will be returned.
     *
     * The geographical features to be searched can be modeled as Polygon and/or Circle geometries
     *
     * represented using any one of the following `GeoJSON` types: **GeoJSON FeatureCollection**,
     *
     * The `geometry` can be represented as a `GeoJSON FeatureCollection` object.
     *
     * This is the recommended option if the geometry contains both Polygons and Circles.
     *
     * The `FeatureCollection` can contain a max of 50 `GeoJSON Feature` objects.
     *
     * Each `Feature` object should represent either a Polygon or a Circle with the following conditions:
     *
     * A `Feature` object for the Polygon geometry can have a max of 50 coordinates and it's properties must be empty.
     *
     * A `Feature` object for the Circle geometry is composed of a _center_ represented using a `GeoJSON Point` type and a _radius_ value
     *
     * (in meters) which must be specified in the object's properties along with the _subType_ property
     *
     * whose value should be 'Circle'.
     *
     * Please see the Examples section below for a sample `FeatureCollection` representation.
     *
     * **GeoJSON GeometryCollection**, The `geometry` can be represented as a `GeoJSON GeometryCollection` object.
     *
     * This is the recommended option if the geometry contains a list of Polygons only.
     *
     * The `GeometryCollection` can contain a max of 50 `GeoJSON Polygon` objects.
     *
     * Each `Polygon` object can have a max of 50 coordinates.
     *
     * Please see the Examples section below for a sample `GeometryCollection` representation.
     *
     * **GeoJSON Polygon**, The `geometry` can be represented as a `GeoJSON Polygon` object.
     *
     * This is the recommended option if the geometry contains a single Polygon.
     *
     * The `Polygon` object can have a max of 50 coordinates.
     *
     * Uses the Post Search Inside Geometry API: https://docs.microsoft.com/rest/api/maps/search/postsearchinsidegeometry
     *
     * @param query The applicable query string (e.g., "seattle", "pizza").
     * @param body This represents the geometry for one or more geographical
     * features (parks, state boundary etc.) to search in and should be a GeoJSON compliant type.
     * Please refer to [RFC 7946](https://tools.ietf.org/html/rfc7946) for details.
     * @param [options] The optional parameters
     * @returns
     * @memberof SearchService
     */
    searchInsideGeometry(query, body, options) {
        let url = this.buildUrl('search/geometry/json');
        url += `&query=${query}`;
        if (options) {
            url += `&${searchInsideGeometryOptionalParamsToQueryString(options)}`;
        }
        return this.httpClient.post(url, body);
    }
    /**
     *
     *
     * **Nearby Search** If you have a use case for only retrieving POI results around a
     *
     * specific location, the nearby search method may be the right choice.
     *
     * This endpoint will only return POI results, and does not take in a search query parameter.
     *
     * Uses the Get Search Nearby API: https://docs.microsoft.com/rest/api/maps/search/getsearchnearby
     *
     *
     *
     * @param location Location where results should be biased.
     * Should be an array of `[longitude, latitude]`, E.g. `[-121.89, 37.337]`.
     * @param [options] The optional parameters
     * @returns
     * @memberof SearchService
     */
    searchNearby(location, options) {
        let url = this.buildUrl(`search/nearby/json`);
        url += `&lon=${location[0]}&lat=${location[1]}`;
        if (options) {
            url += `&${searchNearbyOptionalParamsToQueryString(options)}`;
        }
        return this.httpClient.get(url);
    }
    /**
     *
     *
     * **Get POI by Name** If your search use case only requires POI results, you may use the
     *
     * POI endpoint for searching.
     *
     * This endpoint will only return POI results.
     *
     * Uses the Get Search POI API: https://docs.microsoft.com/rest/api/maps/search/getsearchpoi
     *
     *
     *
     * @param query The POI name to search for (e.g., "statue of liberty", "starbucks").
     * @param [options] The optional parameters
     * @returns
     * @memberof SearchService
     */
    searchPOI(query, options) {
        let url = this.buildUrl('search/poi/json');
        url += `&query=${query}`;
        if (options) {
            url += `&${searchPOIOptionalParamsToQueryString(options)}`;
        }
        return this.httpClient.get(url);
    }
    /**
     *
     *
     * **Get POI by Category** If your search use case only requires POI results filtered by
     *
     * category, you may use the category endpoint.
     *
     * This endpoint will only return POI results which are categorized as specified.
     *
     * List of available categories can be found [here](https://docs.microsoft.com/azure/azure-maps/search-categories).
     *
     * Uses the Get Search POI Category API: https://docs.microsoft.com/rest/api/maps/search/getsearchpoicategory
     *
     *
     *
     * @param query The POI category to search for (e.g., "AIRPORT", "BEACH").
     * @param [options] The optional parameters
     * @returns
     * @memberof SearchService
     */
    searchPOICategory(query, options) {
        let url = this.buildUrl('search/poi/category/json');
        url += `&query=${query}`;
        if (options) {
            url += `&${searchPOICategoryOptionalParamsToQueryString(options)}`;
        }
        return this.httpClient.get(url);
    }
    /**
     *
     *
     * POI Category API provides a full list of supported Points of Interest (POI) categories and subcategories together with their translations and synonyms. The returned content can be used to provide more meaningful results through other Search Service APIs, like Get Search POI.
     *
     *
     *
     * @param [options] The optional parameters.
     * @returns
     * @memberof SearchService
     */
    searchPOICategoryTree(options) {
        let url = this.buildUrl('search/poi/category/tree/json');
        if (options) {
            url += `&${searchPOICategoryTreeOptionalParamsToQueryString(options)}`;
        }
        return this.httpClient.get(url);
    }
    /**
     *
     *
     * The Search Polygon API allows you to request the geometry data such as a city or country
     *
     * outline for a set of entities, previously retrieved from an Online Search request in GeoJSON
     *
     * format. The geometry  ID is returned in the dataSources object under "geometry" and "id" in
     *
     * either a Search Address or Search Fuzzy call.
     *
     *
     *
     * Please note that any geometry ID retrieved from an Online Search endpoint has a limited
     *
     * lifetime. The client  should not store geometry IDs in persistent storage for later referral, as
     *
     * the stability of these identifiers is  not guaranteed for a long period of time. It is expected
     *
     * that a request to the Polygon method is made within a  few minutes of the request to the Online
     *
     * Search method that provided the ID. The service allows for batch  requests up to 20 identifiers.
     *
     *
     *
     * Uses the Get Search Polygon API: https://docs.microsoft.com/rest/api/maps/search/getsearchpolygon
     *
     *
     *
     * @param geometries List of geometry UUIDs, previously retrieved from an Online
     * Search request.
     * @returns
     * @memberof SearchService
     */
    searchPolygons(geometries) {
        const url = this.buildUrl('search/polygon/json') + `&geometries=${geometries.join(',')}`;
        return this.httpClient.get(url);
    }
}
SearchService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: SearchService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
SearchService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: SearchService, providedIn: AzureMapsModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: SearchService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: AzureMapsModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class RouteService {
    constructor(pipelineProvider) {
        this._defaultTimeout = 10000;
        this._routeUrl = new atlas$1.RouteURL(pipelineProvider.getPipeline());
    }
    /**
     *
     *
     * Returns  a route between an origin and a destination, passing through waypoints if they are
     *
     * specified. The route will take into account factors such as current traffic and the typical road
     *
     * speeds on the requested day of the week and time of day.
     *
     *
     *
     * Information returned includes the distance, estimated travel time, and a representation of the
     *
     * route geometry. Additional routing information such as optimized waypoint order or turn by turn
     *
     * instructions is also available, depending on the options selected.
     *
     *
     *
     * Routing service provides a set of parameters for a detailed description of vehicle-specific
     *
     * Consumption Model. Please check [Consumption
     *
     * Model](https://docs.microsoft.com/azure/azure-maps/consumption-model) for detailed explanation
     *
     * of the concepts and parameters involved.
     *
     *
     *
     * If `options.postBody` is specified uses the Post Route Directions API: https://docs.microsoft.com/rest/api/maps/route/postroutedirections
     *
     *
     *
     * Otherwise uses the Get Route Directions API: https://docs.microsoft.com/rest/api/maps/route/getroutedirections
     *
     *
     *
     * @param aborter Create a new Aborter instance with Aborter.none or Aborter.timeout(),
     * goto documents of Aborter for more examples about request cancellation.
     * @param coordinates An array of coordinates through which the route is calculated.
     * Each coordinate is an array of `[longitude, latitude]`. A minimum of two coordinates is required.
     * The first one is the origin and the last is the destination of the route.
     * Optional coordinates in-between act as WayPoints in the route. You can pass up to 150 WayPoints.
     * @param [options]
     * @returns
     * @memberof RouteURL
     */
    calculateRouteDirections(coordinates, options, timeout = this._defaultTimeout) {
        return this
            ._routeUrl
            .calculateRouteDirections(atlas$1.Aborter.timeout(timeout), coordinates, options);
    }
    /**
     *
     *
     * Calculate a set of locations that can be reached from the origin point based
     *
     * on fuel, energy,  or time budget that is specified. A polygon boundary (or Isochrone) is
     *
     * returned in a counterclockwise  orientation as well as the precise polygon center which was the
     *
     * result of the origin point.
     *
     *
     *
     * The returned polygon can be used for further processing such as  [Search Inside
     *
     * Geometry](https://docs.microsoft.com/rest/api/maps/search/getsearchinsidegeometry) to
     *
     * search for POIs within the provided Isochrone.
     *
     *
     *
     * Uses the Get Route Range API: https://docs.microsoft.com/rest/api/maps/route/getrouterange
     *
     *
     *
     * @param aborter Create a new Aborter instance with Aborter.none or Aborter.timeout(),
     * goto documents of Aborter for more examples about request cancellation.
     * @param center The coordinate from which the range calculation should start.
     * @param [options] The optional parameters
     * @returns
     * @memberof RouteURL
     */
    calculateRouteMatrix(body, options, timeout = this._defaultTimeout) {
        return this
            ._routeUrl
            .calculateRouteMatrix(atlas$1.Aborter.timeout(timeout), body, options);
    }
    /**
     *
     *
     * **Note: This API is currently in preview and may be subject to breaking changes.**
     *
     * Calculates a matrix of route summaries for a set of routes
     *
     * defined by origin and destination locations. For every given origin, this service calculates the
     *
     * cost of routing from that origin to every given destination. The set of origins and the set of
     *
     * destinations can be thought of as the column and row headers of a table and each cell in the
     *
     * table contains the costs of routing from the origin to the destination for that cell. For each
     *
     * route, the travel times and distances are calculated. You can use the computed costs to
     *
     * determine which routes to calculate using the Routing Directions API. If waitForResults
     *
     * parameter in the request is set to false (default value), this API returns a 202 response code
     *
     * along a redirect URL in the Location field of the response header. This URL should be checked
     *
     * periodically until the response data or error information is available.
     *
     *
     *
     * The maximum size of a matrix for this API is 700 (the number of origins  multiplied by the
     *
     * number of destinations). With that constraint in mind,  examples of possible matrix dimensions
     *
     * are: 50x10, 10x10, 28x25. 10x70  (it does not need to be square).
     *
     *
     *
     * Calculating a route matrix is considered a long running operation.
     *
     * A long running operations implies that after the initial request is accepted (HTTP 202)
     *
     * the final result will be polled for until available.
     *
     * Each poll request restarts the aborter's timeout, if one was specified.
     *
     *
     *
     * Uses the Post Route Matrix API: https://docs.microsoft.com/rest/api/maps/route/postroutematrixpreview
     *
     *
     *
     * @param aborter Create a new Aborter instance with Aborter.none or Aborter.timeout(),
     * goto documents of Aborter for more examples about request cancellation.
     * @param body The matrix of origin and destination coordinates to compute the route
     * distance, travel time and other summary for each cell of the matrix based on the input
     * parameters. The minimum and the maximum cell count supported are 1 and 700 respectively. For
     * example, it can be 35 origins and 20 destinations or 25 origins and 25 destinations.
     * @param [options] The optional parameters
     * @returns
     * @memberof RouteURL
     */
    calculateRouteRange(center, options, timeout = this._defaultTimeout) {
        return this
            ._routeUrl
            .calculateRouteRange(atlas$1.Aborter.timeout(timeout), center, options);
    }
}
RouteService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: RouteService, deps: [{ token: PipelineProvider }], target: i0.ɵɵFactoryTarget.Injectable });
RouteService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: RouteService, providedIn: AzureMapsModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: RouteService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: AzureMapsModule
                }]
        }], ctorParameters: function () { return [{ type: PipelineProvider }]; } });

class WeatherService extends AtlasHttpService {
    constructor(httpClient) {
        super(httpClient);
    }
    /**
     * Get Current Conditions service returns detailed current weather conditions such as precipitation, temperature and wind for a given coordinate location.
     * Also, observations from the past 6 or 24 hours for a particular location can be retrieved.
     * The basic information returned with the response include details such as observation date and time, brief description of the weather conditions, weather icon, precipitation indicator flags, and temperature.
     * Additional details such as RealFeel™ Temperature and UV index are also returned.
     *
     * @param latitude Latitude
     * @param longitude Longitude
     * @param details Return full details for the current conditions. Available values are
                      - true - Returns full details. By default all details are returned.
                      - false - Returns a truncated version of the current condition data, which includes observation date time, weather phrase, icon code, precipitation indicator flag, and temperature.
     * @param duration Time frame of the returned weather conditions. By default, the most current weather conditions will be returned. Default value is 0. Supported values are:
                      0 - Return the most current weather conditions.
                      6 - Return weather conditions from past 6 hours.
                      24 - Return weather conditions from past 24 hours.
     * @param language Language in which search results should be returned. Should be one of supported IETF language tags, case insensitive. When data in specified language is not available for a specific field, default language is used. Default value is en-us.
     * @param unit Specifies to return the data in either metric units or imperial units. Default value is metric.
     */
    getCurrentConditions(latitude, longitude, details, duration, language, unit) {
        let url = this.buildUrl('weather/currentConditions/json');
        url += `&query=${latitude},${longitude}`;
        if (!(details === null || details === undefined)) {
            url += `&details=${details}`;
        }
        if (!(duration === null || duration === undefined)) {
            url += `&duration=${duration}`;
        }
        if (!(language === null || language === undefined)) {
            url += `&language=${language}`;
        }
        if (!(unit === null || unit === undefined)) {
            url += `&unit=${unit};`;
        }
        return this.httpClient.get(url);
    }
    /**
     * The service returns detailed weather forecast such as temperature and wind by day for the next 1, 5, 10, 15, 25, or 45 days for a given coordinate location. The response include details such as temperature, wind, precipitation, air quality, and UV index.
     *
     * @param latitude Latitude
     * @param longitude Longitude
     * @param duration Specifies for how many days the daily forecast responses are returned. Available values are
                        1 - Return forecast data for the next day. Returned by default.
                        5 - Return forecast data for the next 5 days.
                        10 - Return forecast data for the next 10 days.
                        25 - Return forecast data for the next 25 days. Only available in S1 SKU.
                        45 - Return forecast data for the next 45 days. Only available in S1 SKU.
     * @param language Language in which search results should be returned. Should be one of supported IETF language tags, case insensitive. When data in specified language is not available for a specific field, default language is used. Default value is en-us.
     * @param unit Specifies to return the data in either metric units or imperial units. Default value is metric.
     */
    getDailyForecast(latitude, longitude, duration, language, unit) {
        let url = this.buildUrl('weather/forecast/daily/json');
        url += `&query=${latitude},${longitude}`;
        if (!(duration === null || duration === undefined)) {
            url += `&duration=${duration}`;
        }
        if (!(language === null || language === undefined)) {
            url += `&language=${language}`;
        }
        if (!(unit === null || unit === undefined)) {
            url += `&unit=${unit};`;
        }
        return this.httpClient.get(url);
    }
    /**
     * Request detailed weather forecast by the hour for the next 1, 12, 24 (1 day), 72 (3 days), 120 (5 days), and 240 hours (10 days) for the given the given coordinate location. The API returns details such as temperature, humidity, wind, precipitation, and ultraviolet (UV) index.
     *
     * @param latitude Latitude
     * @param longitude Longitude
     * @param duration Time frame of the returned weather forecast. By default, the forecast data for next hour will be returned. Available values are
                        1 - Return forecast data for the next hour. Default value.
                        12 - Return hourly forecast for next 12 hours.
                        24 - Return hourly forecast for next 24 hours.
                        72 - Return hourly forecast for next 72 hours (3 days).
                        120 - Return hourly forecast for next 120 hours (5 days). Only available in S1 SKU.
                        240 - Return hourly forecast for next 240 hours (10 days). Only available in S1 SKU.
     * @param language Language in which search results should be returned. Should be one of supported IETF language tags, case insensitive. When data in specified language is not available for a specific field, default language is used. Default value is en-us.
     * @param unit Specifies to return the data in either metric units or imperial units. Default value is metric.
     */
    getHourlyForecast(latitude, longitude, duration, language, unit) {
        let url = this.buildUrl('weather/forecast/hourly/json');
        url += `&query=${latitude},${longitude}`;
        if (!(duration === null || duration === undefined)) {
            url += `&duration=${duration}`;
        }
        if (!(language === null || language === undefined)) {
            url += `&language=${language}`;
        }
        if (!(unit === null || unit === undefined)) {
            url += `&unit=${unit};`;
        }
        return this.httpClient.get(url);
    }
    /**
     * Get Minute Forecast service returns minute-by-minute forecasts for a given location for the next 120 minutes. Users can request weather forecasts in the interval of 1, 5 and 15 minutes. The response will include details such as the type of precipitation (including rain, snow, or a mixture of both), start time, and precipitation intensity value (dBZ).
     *
     * @param latitude Latitude
     * @param longitude Longitude
     * @param interval Specifies time interval in minutes for the returned weather forecast. Supported values are
                      1 - Retrieve forecast for 1-minute intervals. Returned by default.
                      5 - Retrieve forecasts for 5-minute intervals.
                      15 - Retrieve forecasts for 15-minute intervals.
     * @param language Language in which search results should be returned. Should be one of supported IETF language tags, case insensitive. When data in specified language is not available for a specific field, default language is used. Default value is en-us.
     */
    getMinuteForecast(latitude, longitude, interval, language) {
        let url = this.buildUrl('weather/forecast/minute/json');
        url += `&query=${latitude},${longitude}`;
        if (!(interval === null || interval === undefined)) {
            url += `&interval=${interval}`;
        }
        if (!(language === null || language === undefined)) {
            url += `&language=${language}`;
        }
        return this.httpClient.get(url);
    }
    /**
     * Service returns detailed weather forecast by quarter-day for the next 1, 5, 10, or 15 days for a given location. Response data is presented by quarters of the day - morning, afternoon, evening, and overnight. Details such as temperature, humidity, wind, precipitation, and UV index are returned.Service returns detailed weather forecast by quarter-day for the next 1, 5, 10, or 15 days for a given location. Response data is presented by quarters of the day - morning, afternoon, evening, and overnight. Details such as temperature, humidity, wind, precipitation, and UV index are returned.
     *
     * @param latitude Latitude
     * @param longitude Longitude
     * @param duration Specifies for how many days the quester-day forecast responses are returned. Supported values are:
                        1 - Return forecast data for the next day. Returned by default.
                        5 - Return forecast data for the next 5 days.
                        10 - Return forecast data for next 10 days.
                        15 - Return forecast data for the next 15 days.
     * @param language Language in which search results should be returned. Should be one of supported IETF language tags, case insensitive. When data in specified language is not available for a specific field, default language is used. Default value is en-us.
     * @param unit Specifies to return the data in either metric units or imperial units. Default value is metric.
     */
    getQuarterDayForecast(latitude, longitude, duration, language, unit) {
        let url = this.buildUrl('weather/forecast/quarterDay/json');
        url += `&query=${latitude},${longitude}`;
        if (!(duration === null || duration === undefined)) {
            url += `&duration=${duration}`;
        }
        if (!(language === null || language === undefined)) {
            url += `&language=${language}`;
        }
        if (!(unit === null || unit === undefined)) {
            url += `&unit=${unit};`;
        }
        return this.httpClient.get(url);
    }
    /**
     * Weather along a route API returns hyper local (one kilometer or less), up-to-the-minute weather nowcasts, weather hazard assessments, and notifications along a route described as a sequence of waypoints. This includes a list of weather hazards affecting the waypoint or route, and the aggregated hazard index for each waypoint might be used to paint each portion of a route according to how safe it is for the driver. When submitting the waypoints, it is recommended to stay within, or close to, the distance that can be traveled within 120-mins or shortly after. Data is updated every five minutes.
      The service supplements Azure Maps Route Service that allows you to first request a route between an origin and a destination and use that as an input for Weather Along Route endpoint.
      In addition, the service supports scenarios to generate weather notifications for waypoints that experience an increase in intensity of a weather hazard. For example, if the vehicle is expected to begin experiencing heavy rain as it reaches a waypoint, a weather notification for heavy rain will be generated for that waypoint allowing the end product to display a heavy rain notification before the driver reaches that waypoint. The trigger for when to display the notification for a waypoint could be based, for example, on a geofence, or selectable distance to the waypoint.
      The API covers all regions of the planet except latitudes above Greenland and Antarctica.
     *
     * @param waypoints Coordinates through which the route is calculated, separated by colon (:) and entered in chronological order. A minimum of two waypoints is required. A single API call may contain up to 60 waypoints. A waypoint indicates location, ETA, and optional heading.
     * @param language Language in which search results should be returned. Should be one of supported IETF language tags, case insensitive. When data in specified language is not available for a specific field, default language is used. Default value is en-us.
     */
    getWeatherAlongRoute(waypoints, language) {
        if (waypoints === null || waypoints === undefined || waypoints.length < 2) {
            throw new Error('A minimum of two waypoints is required');
        }
        if (waypoints.length > 60) {
            throw new Error('A single API call may contain up to 60 waypoints');
        }
        const query = waypoints.map(waypoint => {
            let waypointQuery = `${waypoint.latitude},${waypoint.longitude},${waypoint.eta}`;
            if (waypoint.heading !== null && waypoint.heading !== undefined) {
                waypointQuery += `,${waypoint.heading}`;
            }
            return waypointQuery;
        }).join(':');
        let url = this.buildUrl('weather/route/json');
        url += `&query=${query}`;
        if (!(language === null || language === undefined)) {
            url += `&language=${language}`;
        }
        return this.httpClient.get(url);
    }
}
WeatherService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: WeatherService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
WeatherService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: WeatherService, providedIn: AzureMapsModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: WeatherService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: AzureMapsModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { AZUREMAPS_CONFIG, AzureMapDirective, AzureMapsConfiguration, AzureMapsModule, BubbleLayerDirective, CompassControlDirective, ConnectorSet, DrawingToolbarDirective, ExtendedPostalCodes, HeatmapLayerDirective, HtmlMarkerDirective, ImageLayerDirective, LineLayerDirective, PitchControlDirective, PolygonExtrusionLayerDirective, PolygonLayerDirective, PopupDirective, RoadUse, RouteService, SearchService, StyleControlDirective, SymbolLayerDirective, TileLayerDirective, WeatherService, ZoomControlDirective, setAzureMapsConfiguration };
